

import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import SideNav from "./SideNav";
import TopBar from "./TopBar";
import Swal from 'sweetalert2';
import UserContext from './UserContext';
import moment from 'moment';
import {Link, useParams, useNavigate} from "react-router-dom";
import QRCode from 'qrcode';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Modal, Button, Form } from 'react-bootstrap'; 
dayjs.extend(customParseFormat);


function EditBooking() {

    const { booking_id } = useParams();

    const API_BASE_URL = process.env.REACT_APP_BASE_URL;
    const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;

    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);
    const [title, setTitle] = useState('');
    const [startDatetime, setStartDatetime] = useState('');
    const [endDatetime, setEndDatetime] = useState('');
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [loading, setLoading] = useState(false);
    const [timeSlotLoading, setTimeSlotLoading] = useState(false);
    const [error_list, setErrorList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [availableTimeSlots, setAvailableTimeSlot] = useState([]);
    const [kids_count, setKids_count] = useState(0);
    const [adults_count, setAdults_count] = useState(0);
    const [deposit_amount, setDeposit_amount] = useState(0);
    const [min_game, setMin_game] = useState(0);
    const [deposit_details, setDeposit_details] = useState('');
    const [grand_total, setGrand_total] = useState(0);
    const [amount_paid, setAmount_paid] = useState(0);
    const [extraPlayerPrice, setExtraPlayerPrice] = useState(0);
    const [extraGamePrice, setExtraGamePrice] = useState(0);
    const [minPlayers, setMinPlayers] = useState(0);
    const [maxPlayers, setMaxPlayers] = useState(0);
    const [hst, setHst] = useState(0);
    const [totalBeforeHst, setTotalBeforeHst] = useState(0);
    const [basic_price, setBasic_price] = useState(0);
    const [bookingErrorList, setBookingErrorList] = useState([]);
    const [totalPlayersErrorList, setTotalPlayersErrorList] = useState([]);
   
    const [gameCountErrorList, setGameCountErrorList] = useState([]);
    const [eventGameCountErrorList, setEventGameCountErrorList] = useState([]);
    const [booking_date, setBooking_date] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [booking_time, setBooking_time] = useState('');
    const [cart_details, setCart_details] = useState('');
    const [bookingAvailableTimeSlots, setBookingAvailableTimeSlots] = useState([]);
    const [disabledTimeSlots, setDisabledTimeSlots] = useState([]);
    const userContext = useContext(UserContext);
    const [team, setTeam] = useState([]);

    const [games, setGames] = useState([]);
    const [game_types, setGame_types] = useState([]);
    const [game_packages, setGame_packages] = useState([]);
    const [corporate_events, setCorporate_events] = useState([]);
    const [game_types_array, setGame_types_array] = useState([]);
    const [selectedGame, setSelectedGame] = useState('');
    const [selectedGameType, setSelectedGameType] = useState('');
    const [selectedGameLocation, setSelectedGameLocation] = useState('');

    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [note, setNote] = useState("");
    const [locations, setLocations] = useState([]);
    const [game_available, setGame_available] = useState([]);
    const [timeSlotDetails, setTimeSlotDetails] = useState([]);
    const [availableSpaces, setAvailableSpaces] = useState({});
    const [error, setError] = useState('');
    const [bookingDetails, setBookingDetails] = useState({});
    const [view, setView] = useState('form');
    const [selectedPackageType, setSelectedPackageType] = useState("");
    const [selectedBirthdayPackage, setSelectedBirthdayPackage] = useState('');
    const [selectedCorporatePackage, setSelectedCorporatePackage] = useState('');
    const [birthdayKid, setBirthdayKid] = useState("");
    const [selectedFoods, setSelectedFoods] = useState({});
    const [selectedDrinks, setSelectedDrinks] = useState({});
    const [selectedEventFoods, setSelectedEventFoods] = useState('');
    const [selectedEventDrinks, setSelectedEventDrinks] = useState('');
    const [birthdayPrice, setBirthdayPrice] = useState([]);
    const [corporatePrice, setCorporatePrice] = useState([]);
    const [game_count, setGame_count] = useState([]);
    const [eventGame_count, setEventGame_count] = useState([]);
    const [foodOptions, setFoodOptions] = useState([]);
    const [drinkOptions, setDrinkOptions] = useState([]);
    const [eventFoodOptions, setEventFoodOptions] = useState([]);
    const [eventDrinkOptions, setEventDrinkOptions] = useState([]);
    const [birthday_packages, setBirthday_packages] = useState([]);
    const [corporate_packages, setCorporate_packages] = useState([]);
    const [filteredLocations, setFilteredLocations] = useState([]);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [email_error_list, setEmailErrorList] = useState({
        to: '',
        subject: '',
        message: ''
    });
    const [emailData, setEmailData] = useState({
        to: '',
        subject: '',
        message: ''
    });

    const [email_template, setEmail_template] = useState([]);
    const [template, setTemplate] = useState("");
    const [template_details, setTemplate_details] = useState([]);
    const [images, setImages] = useState([]);
 
    const [payment_method, setPayment_method] = useState('');
    const [fullyBookedDates, setFullyBookedDates] = useState({});
    const [initialSelectionDone, setInitialSelectionDone] = useState(false);
    const [corporateInitialSelectionDone, setCorporateInitialSelectionDone] = useState(false);
    const [eventInitialSelectionDone, setEventInitialSelectionDone] = useState(false);
    const [initialSelectionSlots, setInitialSelectionSlots] = useState('');
    const [corporateInitialSelectionSlots, setCorporateInitialSelectionSlots] = useState('');
    const [holiday, setHoliday] = useState([]);

    const [customerById, setCustomerById] = useState([]);
    const [depositInfo, setDepositInfo] = useState('');
 const [sub_total, setSub_total] = useState(0);
 const [food_details, setFood_details] = useState('');
 const [isBookingDataLoaded, setIsBookingDataLoaded] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState([]);
const [discountDetails, setDiscountDetails] = useState([]);
const [promoDetails, setPromoDetails] = useState([]);
const [showDiscountModal, setShowDiscountModal] = useState(false);
const [showPromoModal, setShowPromoModal] = useState(false);
const [discountType, setDiscountType] = useState('');
const [discountValue, setDiscountValue] = useState('');
const [discountAmount, setDiscountAmount] = useState(0);
const [promoAmount, setPromoAmount] = useState(0);
const [adjustedTotal, setAdjustedTotal] = useState(0);
const [discountDescription, setDiscountDescription] = useState("");
const [promoCodeList, setPromoCodeList] = useState([]);
const [promoCode, setPromoCode] = useState("");
 const [adjustmentHistory, setAdjustmentHistory] = useState([]);
 const [removedPromos, setRemovedPromos] = useState([]);

  const today = (() => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  })();



  useEffect(() => {
    if (userContext.username && booking_id) {
        loadAllData();
    }
}, [userContext.username, booking_id]);

const loadAllData = async () => {
    try {
        setIsLoading(true);
        const locationLoaded = await getLocationByUser(); // waits for locations and selected game location
        if (locationLoaded) {
            await getCustomerById(booking_id); // loads all booking info
            await getEmailTemplateList();      // loads template after booking
        }
    } catch (error) {
        console.error("Error loading data:", error);
    } finally {
        setIsLoading(false);
    }
};


    // useEffect(() => {
    //     if (userContext.username ) {
    //         getLocationByUser();
   
    //     }
    // }, [userContext.username]); 

    useEffect(() => {
        // Check if email_template is loaded and has the required default template
        const defaultTemplate = email_template.find(item => item.template_name === 'Booking Updation');
        if (defaultTemplate) {
            setTemplate('Booking Updation');
            setTemplate_details(defaultTemplate);
    
            setEmailData({
                ...emailData,
                subject: defaultTemplate.subject,
                message: defaultTemplate.message
            });
        } else {
            // Reset if default template is not found
            setTemplate("");
            setTemplate_details({});
            setEmailData({ subject: "", message: "", to: "" });
        }
    }, [email_template]);
    
    async function getLocationByUser() {
        try {
            const res = await axios.get(`${API_URL}/view-team-member-by-username/${userContext.username}`);
            const response = await axios.get(`${API_URL}/view-booked-slots-by-id-edit/${booking_id}`);
    
            if (res.data.status === 200 && response.data.status === 200) {
                const filtered = res.data.locations;
                const bookedSlot = response.data.bookedSlot;
                setFilteredLocations(filtered);
    
                if (filtered.length > 0) {
                    const bookingLocationId = bookedSlot.location_id;
                    const isValidLocation = filtered.some(loc => loc.id === bookingLocationId);
                    const finalLocationId = isValidLocation ? bookingLocationId : filtered[0].id;
    
                    setSelectedGameLocation(finalLocationId);
                    await fetchGameAvailable(finalLocationId); // ensure it's awaited
                }
                return true;
            } else {
                console.warn("Location or booked slot not found");
                return false;
            }
        } catch (error) {
            console.error("Error fetching location or slot:", error);
            return false;
        }
    }
    
    
  function getPromoCodeList()
        {    
          axios.get(`${API_URL}/view-active-code`).then(res=>{
              if(res.data.status === 200){
                  setPromoCodeList(res.data.promoCodes);  
              }     
              else if(res.data.status === 404){
                setPromoCodeList([]);
                 // setMessage(res.data.message);     
                  }             
           });    
        }
  
    async function getCustomerById(booking_id) {


        try {
            const res = await axios.get(`${API_URL}/view-booked-slots-by-id/${booking_id}`);
            if (res.data.status === 200) {
                const bookedSlot = res.data.bookedSlot;
                const formattedBookedTime = formatBookedTime(bookedSlot.booked_time);
                //console.log(bookedSlot)

 let parsedDiscountDetails = [];

      try {
        if (bookedSlot.discount_details) {
          parsedDiscountDetails = typeof bookedSlot.discount_details === "string"
            ? JSON.parse(bookedSlot.discount_details)
            : bookedSlot.discount_details;
        }
      } catch (err) {
        console.error("Failed to parse discount_details:", err);
      }

      let parsedPromoDetails = [];

      try {
        if (bookedSlot.promo_details) {
          parsedPromoDetails = typeof bookedSlot.promo_details === "string"
            ? JSON.parse(bookedSlot.promo_details)
            : bookedSlot.promo_details;
        }
      } catch (err) {
        console.error("Failed to parse promo_details:", err);
      }



                setCustomerById({
                    ...bookedSlot,
                    booked_time_formatted: formattedBookedTime,
                    booking_time: bookedSlot.booked_time,
                    consent_form_details: bookedSlot.consent_form_details ? JSON.parse(bookedSlot.consent_form_details) : [],
                    kids_form_details: bookedSlot.kids_form_details ? JSON.parse(bookedSlot.kids_form_details) : [],
                    cart_details: bookedSlot?.cart_details ? JSON.parse(bookedSlot.cart_details) : [],
                  
                });

    
        if (bookedSlot.package_name === 'Birthday') {
          
            setSelectedPackageType('birthday_package');
           // fetchGamePackages(1);
            setSelectedBirthdayPackage(bookedSlot.game_package_id);
            fetchOptionsForBirthdayPackage(bookedSlot.game_package_id);
            setBirthdayKid(bookedSlot.birthday_kid_name);
            setInitialSelectionSlots(JSON.parse(bookedSlot.booked_time));
            setInitialSelectionDone(true); 
            setBasic_price(bookedSlot.package_price);
            setExtraGamePrice(bookedSlot.extra_game_price);
            setExtraPlayerPrice(bookedSlot.extra_player_price);
           
        } else if (bookedSlot.package_name === 'Corporate') {
            setSelectedPackageType('corporate_event');
            setSelectedCorporatePackage(bookedSlot.corporate_package_id);
            fetchOptionsForCorporatePackage(bookedSlot.corporate_package_id);
            setBirthdayKid(bookedSlot.birthday_kid_name);
            setCorporateInitialSelectionSlots(JSON.parse(bookedSlot.booked_time));
            setCorporateInitialSelectionDone(true); 
            setBasic_price(bookedSlot.package_price);
            setExtraGamePrice(bookedSlot.extra_game_price);
            setExtraPlayerPrice(bookedSlot.extra_player_price);
        
        } else if (bookedSlot.game_type_name) {
            setSelectedPackageType('laser_tag_package');
            setSelectedGameType(bookedSlot.game_type_id);
          }
          
            // setSelectedGameLocation(bookedSlot.game_location_id);
            // setSelectedGame(bookedSlot.game_id);
            setFirstname(bookedSlot.firstname);
            setLastname(bookedSlot.lastname);
            setEmail(bookedSlot.email);
            setPhone(bookedSlot.phone);
            setHst(bookedSlot.hst);
            setSub_total(bookedSlot.subtotal);
            setGrand_total(bookedSlot.grand_total);
            setAmount_paid(bookedSlot.amount_paid);
            setBooking_date(bookedSlot.booked_date);
            setSelectedDate(bookedSlot.booked_date);
            setGame_count(bookedSlot.no_of_slots);
            setBooking_time(JSON.parse(bookedSlot.booked_time));
            setAdults_count(bookedSlot.no_of_adults);   
            setKids_count(bookedSlot.no_of_children);
            
            setDiscountDetails(parsedDiscountDetails);
            setPromoDetails(parsedPromoDetails);
            setDiscountAmount(bookedSlot.discount_amount);
            setPromoAmount(bookedSlot.promo_amount); 
               
            setAdjustedTotal(bookedSlot.adjusted_total);
            setAdjustmentHistory(res.data.adjustmentLogs.filter(item=> item.is_delete === 0));


            // setSelectedFoods(JSON.parse(bookedSlot?.food_details));   
            // setSelectedDrinks(JSON.parse(bookedSlot?.drink_details));  
            setSelectedFoods(bookedSlot.food_details ? JSON.parse(bookedSlot.food_details) : {}); 
            setSelectedDrinks(bookedSlot.drink_details ? JSON.parse(bookedSlot.drink_details) : {});

const subtotal = parseFloat(bookedSlot?.subtotal) || 0;
const discountAmount = parseFloat(bookedSlot?.discount_amount) || 0;
const promoAmount = parseFloat(bookedSlot?.promo_amount) || 0;

const adjustmentLogs = res.data.adjustmentLogs?.filter(item => item.is_delete === 0) || [];
const totalAdjustments = adjustmentLogs.reduce(
  (sum, item) => sum + (parseFloat(item.adjusted_amount) || 0),
  0
);

const totalBeforeHst = subtotal + totalAdjustments - discountAmount - promoAmount;
const formattedTotalBeforeHst = totalBeforeHst; // This will now work correctly

            setTotalBeforeHst(formattedTotalBeforeHst);
            setPaymentHistory(res.data.payments.filter(payment => payment.is_deleted === 0));
            setNote(bookedSlot.note);
            setIsBookingDataLoaded(true);
            return true;
        } else {
            console.warn("Booking not found");
            return false;
        }
    } catch (error) {
        console.error("Error fetching booking:", error);
        return false;
    }
}

        // useEffect(() => {
        //     if (booking_id && selectedGame && selectedGameLocation) {
        //         getCustomerById(booking_id);
        //     }
        // }, [booking_id, selectedGame, selectedGameLocation]);

        useEffect(() => {
            if (booking_id) {
                getCustomerById(booking_id);
                getEmailTemplateList();
                getPromoCodeList();
            }
        }, [booking_id]);
        
        
   
   

    useEffect(() => {
  
        if (selectedGameType && selectedGame && selectedGameLocation) {
            //setIsLoading(true);
            fetchGameTypesArray();
            //setIsLoading(false);
        }
    }, [selectedGameType , selectedGame, selectedGameLocation]);



 
    const handleViewBookings = (bookingId) => {
        navigate('/booking-details/'+bookingId);      
      };

      const handleIncrement = (food) => {
        setSelectedFoods((prev) => ({
          ...prev,
          [food]: (prev[food] || 0) + 1
        }));
      };
      
      const handleDecrement = (food) => {
        setSelectedFoods((prev) => ({
          ...prev,
          [food]: Math.max((prev[food] || 1) - 1, 0)
        }));
      };

  
      
      const getTotalSelectedFoods = () => {
        return Object.values(selectedFoods).reduce((total, count) => total + count, 0);
      };

      const handleDrinkIncrement = (drink) => {
        
        setSelectedDrinks((prev) => ({
          ...prev,
          [drink]: (prev[drink] || 0) + 1
        }));
      };
      
      const handleDrinkDecrement = (drink) => {
        setSelectedDrinks((prev) => ({
          ...prev,
          [drink]: Math.max((prev[drink] || 1) - 1, 0)
        }));
      };

      const getTotalSelectedDrinks = () => {
        return Object.values(selectedDrinks).reduce((total, count) => total + count, 0);
      };



      const handleEventFoodIncrement = (food) => {
        setSelectedEventFoods((prev) => ({
          ...prev,
          [food]: (prev[food] || 0) + 1
        }));
      };
      
      const handleEventFoodDecrement = (food) => {
        setSelectedEventFoods((prev) => ({
          ...prev,
          [food]: Math.max((prev[food] || 1) - 1, 0)
        }));
      };

  
      
      const getTotalSelectedEventFoods = () => {
        return Object.values(selectedEventFoods).reduce((total, count) => total + count, 0);
      };

      const handleEventDrinkIncrement = (drink) => {
        setSelectedEventDrinks((prev) => ({
          ...prev,
          [drink]: (prev[drink] || 0) + 1
        }));
      };
      
      const handleEventDrinkDecrement = (drink) => {
        setSelectedEventDrinks((prev) => ({
          ...prev,
          [drink]: Math.max((prev[drink] || 1) - 1, 0)
        }));
      };

      const getTotalSelectedEventDrinks = () => {
        return Object.values(selectedEventDrinks).reduce((total, count) => total + count, 0);
      };



    const fetchOptionsForBirthdayPackage = async (selectedBirthdayPackageId) => {
        try {
       
          const response = await axios.get(`${API_URL}/view-game-package-by-selectedBirthdayId/${selectedBirthdayPackageId}`);
          setBirthday_packages(response.data.gamePackages[0]);
        

         const foodDetails = response.data.gamePackages[0].food_details || '';
      const drinkDetails = response.data.gamePackages[0].drink_details || '';

      setFoodOptions(foodDetails.split(',').map(item => item.trim()).filter(item => item));
      setDrinkOptions(drinkDetails.split(',').map(item => item.trim()).filter(item => item));
       setGame_count(response.data.gamePackages[0].min_games)
    } catch (error) {
          console.error("Error fetching locations:", error);
        }
      };

      const fetchOptionsForCorporatePackage = async (selectedCorporatePackageId) => {
        try {
       
          const response = await axios.get(`${API_URL}/view-corporate-event-by-selectedCorporateId/${selectedCorporatePackageId}`);
          setCorporate_packages(response.data.corporateEvents[0]);
         // console.log(response.data.corporateEvents[0])

         const foodDetails = response.data.corporateEvents[0].food_details || '';
      const drinkDetails = response.data.corporateEvents[0].drink_details || '';

      setEventFoodOptions(foodDetails.split(',').map(item => item.trim()).filter(item => item));
      setEventDrinkOptions(drinkDetails.split(',').map(item => item.trim()).filter(item => item));
       setEventGame_count(response.data.corporateEvents[0].min_games)
    } catch (error) {
          console.error("Error fetching locations:", error);
        }
      };


        function getEmailTemplateList()
        {    
          axios.get(`${API_URL}/view-email-template`).then(res=>{
              if(res.data.status === 200){
                  setEmail_template(res.data.emailTemplate);       
              }     
              else if(res.data.status === 404){
                setEmail_template([]);
                 // setMessage(res.data.message);     
                  }             
           });    
        }

   

    const fetchTimeSlots = async () => {
        setTimeSlotLoading(true);
        try {
         
            const response = await axios.get(`${API_URL}/fetch-time-slots`, {
                params: {
                    location_id: selectedGameLocation,
                    game_id: selectedGame,
                    game_type_id: selectedGameType,
                    selected_date: selectedDate,
                    created_by: userContext.userDetails.id,
                }
            });
            //   setTimeSlotDetails(prevState => ({
            //     ...prevState,
            //     [selectedGameType]: response.data // Assuming the response is an array with one object for the selected game type
            //   }));


            setTimeSlotDetails(response.data);
          
            const timeSlot = response.data;

            const { start_time, end_time, time_slot_interval } = timeSlot;
            const timeSlots = calculateTimeSlots(start_time, end_time, parseInt(time_slot_interval, 10));
            const formattedTimeSlots = formatTimeSlots(timeSlots);


            //   console.log('Generated Time Slots:', timeSlots);
            const comparisonResponse = await axios.post(`${API_URL}/compare-time-slots`, {
                location_id: selectedGameLocation,
                game_id: selectedGame,
                game_type_id: selectedGameType,
                selected_date: selectedDate,
                generated_time_slots: formattedTimeSlots,
                no_of_adults: adults_count,
                no_of_children: kids_count,
            });

            const { disabledTimeSlots, availableSpaces } = comparisonResponse.data;

            setTimeSlotDetails(timeSlot);
            setBookingAvailableTimeSlots(formattedTimeSlots);
            setDisabledTimeSlots(disabledTimeSlots);
 
            setAvailableSpaces(availableSpaces);

            await new Promise(resolve => setTimeout(resolve, 300));

           //  console.log('Fetched Data:', comparisonResponse.data);

        } catch (error) {
            console.error('Error fetching data:', error);

        }
        setTimeSlotLoading(false);
    }


    const fetchTimeSlotsBirthday = async () => {
        setTimeSlotLoading(true);
     
        try {
            const response = await axios.get(`${API_URL}/fetch-time-slots-birthday`, {
                params: {
                    location_id: selectedGameLocation,
                    game_id: selectedGame,
                    game_package_id: selectedBirthdayPackage,
                    selected_date: selectedDate,
                    created_by: userContext.userDetails.id,
                }
            });
           


            setTimeSlotDetails(response.data);
            const timeSlot = response.data;

            const { start_time, end_time, time_slot_interval } = timeSlot;
            const timeSlots = calculateTimeSlots(start_time, end_time, parseInt(time_slot_interval, 10));
            const formattedTimeSlots = formatTimeSlots(timeSlots);

    
            const comparisonResponse = await axios.post(`${API_URL}/compare-time-slots-birthday`, {
                location_id: selectedGameLocation,
                game_id: selectedGame,
                game_package_id: selectedBirthdayPackage,
                // game_type_id: selectedGameType,
                selected_date: selectedDate,
                generated_time_slots: formattedTimeSlots,
                no_of_adults: adults_count,
                no_of_children: kids_count,
            });

            const { disabledTimeSlots, availableSpaces } = comparisonResponse.data;

             
            
            setTimeSlotDetails(timeSlot);
            setBookingAvailableTimeSlots(formattedTimeSlots);
            setDisabledTimeSlots(disabledTimeSlots);
            // console.log(availableSpaces);
            setAvailableSpaces(availableSpaces);

            await new Promise(resolve => setTimeout(resolve, 300));

            // console.log('Fetched Data:', comparisonResponse.data);

        } catch (error) {
            console.error('Error fetching data:', error);

        }
        setTimeSlotLoading(false);
    }

    const fetchTimeSlotsCorporate = async () => {
        setTimeSlotLoading(true);
        try {
            const response = await axios.get(`${API_URL}/fetch-time-slots-corporate`, {
                params: {
                    location_id: selectedGameLocation,
                    game_id: selectedGame,
                    corporate_event_id: selectedCorporatePackage,
                    selected_date: selectedDate,
                    created_by: userContext.userDetails.id,
                }
            });
           


            setTimeSlotDetails(response.data);
            const timeSlot = response.data;

            const { start_time, end_time, time_slot_interval } = timeSlot;
            const timeSlots = calculateTimeSlots(start_time, end_time, parseInt(time_slot_interval, 10));
            const formattedTimeSlots = formatTimeSlots(timeSlots);

    
            const comparisonResponse = await axios.post(`${API_URL}/compare-time-slots-corporate`, {
                location_id: selectedGameLocation,
                game_id: selectedGame,
                corporate_event_id: selectedCorporatePackage,
                // game_type_id: selectedGameType,
                selected_date: selectedDate,
                generated_time_slots: formattedTimeSlots,
                no_of_adults: adults_count,
                no_of_children: kids_count,
            });

            const { disabledTimeSlots, availableSpaces } = comparisonResponse.data;
            
            setTimeSlotDetails(timeSlot);
            setBookingAvailableTimeSlots(formattedTimeSlots);
            setDisabledTimeSlots(disabledTimeSlots);
            setAvailableSpaces(availableSpaces);
            //console.log(disabledTimeSlots);
            await new Promise(resolve => setTimeout(resolve, 300));

            // console.log('Fetched Data:', comparisonResponse.data);

        } catch (error) {
            console.error('Error fetching data:', error);

        }
        setTimeSlotLoading(false);
    }




    function fetchGameAvailable(locationId) {
       // setIsLoading(true); // Start loader for game fetching
        axios.get(`${API_URL}/view-available-game-by-locationId/${locationId}`)
            .then(res => {
                if (res.data.games) {
                    setGame_available(res.data.games);
                    if (res.data.games.length > 0) {
                        setSelectedGame(res.data.games[0].id);
                    } else {
                        setSelectedGame('');
                    }
                } else {
                    setGame_available([]);
                }
            })
            .catch(error => {
                console.error("Error fetching games:", error);
            })
            setIsLoading(false);
    }

   



    useEffect(() => {

 if(selectedGame && selectedGameLocation){
   //setBooking_time([]);
if(minPlayers && maxPlayers){
    if(selectedGameType && (adults_count + kids_count)  > 1){
   
  const totalPlayers = Number(kids_count) + Number(adults_count);

  if (totalPlayers < minPlayers || totalPlayers > maxPlayers) {
      setTotalPlayersErrorList(`The total number of players must be between ${minPlayers} and ${maxPlayers}.`);
      setBookingAvailableTimeSlots([]);
  } 
 
     else {
        fetchTimeSlots();
        setTotalPlayersErrorList('');

     }
    
}  
}


if(selectedBirthdayPackage && game_count >= birthday_packages.min_games &&  (adults_count + kids_count)  > 1)
{
   // setBooking_time([]);
   // setInitialSelectionDone(false);
    // const filteredPackage = game_packages.filter(item => item.id === Number(selectedBirthdayPackage));
    //         const max_players_in_a_slot = filteredPackage[0].max_players_in_a_slot;


    const totalPlayers = Number(kids_count) + Number(adults_count);

  
    if (selectedBirthdayPackage && (totalPlayers < birthday_packages.min_players || totalPlayers > birthday_packages.max_players_in_a_slot)) {
        setTotalPlayersErrorList(`The total number of players for a birthday package must be between ${birthday_packages.min_players} and ${birthday_packages.max_players_in_a_slot}.`);
        setBookingAvailableTimeSlots([]);
    } 
    else {
        setTotalPlayersErrorList('');
        fetchTimeSlotsBirthday();
     }

}

if(selectedCorporatePackage && eventGame_count >= corporate_packages.min_games &&  (adults_count + kids_count)  > 1)
    {
      //  setBooking_time([]);
      //  setEventInitialSelectionDone(false);
        // const filteredPackage = game_packages.filter(item => item.id === Number(selectedBirthdayPackage));
        //         const max_players_in_a_slot = filteredPackage[0].max_players_in_a_slot;
    
        const totalPlayers = Number(kids_count) + Number(adults_count);
        if (selectedCorporatePackage && totalPlayers < corporate_packages.min_players || totalPlayers > corporate_packages.max_players_in_a_slot) {
            setBookingAvailableTimeSlots([]);
            setTotalPlayersErrorList(`The total number of players for a corporate package must be between ${corporate_packages.min_players}. and ${corporate_packages.max_players_in_a_slot}.`);
          
        } 
        else {
            setTotalPlayersErrorList('');
            fetchTimeSlotsCorporate();
         }
    }



if(game_count < birthday_packages.min_games)
    {
        setBookingAvailableTimeSlots([]);
        setGameCountErrorList(`Please select min. ${birthday_packages.min_games} games.`);
  
    }
    else{
        setGameCountErrorList('');
    }

    if(eventGame_count < corporate_packages.min_games)
        {
            setBookingAvailableTimeSlots([]);
            setEventGameCountErrorList(`Please select min. ${corporate_packages.min_games} games.`);
      
        }
        else{
            setEventGameCountErrorList('');
        }

    }


    }, [adults_count, kids_count, game_count, eventGame_count, selectedPackageType, selectedGame, selectedGameLocation, minPlayers, maxPlayers ]);




    // Function to format time slots into ranges
    const formatTimeSlots = (timeSlots) => {
        const formattedSlots = [];

        for (let i = 0; i < timeSlots.length - 1; i++) {
            const startTime = timeSlots[i];
            const endTime = timeSlots[i + 1];

            // Convert to 12-hour format
            const startTime12h = convertTo12HourFormat(startTime);
            const endTime12h = convertTo12HourFormat(endTime);

            // Format the range
            const formattedRange = `${startTime12h} - ${endTime12h}`;
            formattedSlots.push(formattedRange);
        }

        return formattedSlots;
    };

    // Function to convert 24-hour time to 12-hour format
    const convertTo12HourFormat = (time24h) => {
        const [hours, minutes] = time24h.split(':');
        let period = 'AM';
        let hours12 = parseInt(hours, 10);

        if (hours12 === 0) {
            hours12 = 12;
        } else if (hours12 === 12) {
            period = 'PM';
        } else if (hours12 > 12) {
            hours12 -= 12;
            period = 'PM';
        }

        return `${hours12.toString().padStart(2, '0')}:${minutes} ${period}`;
    };


    // const fetchGames = async () => {
    //     try {
    //         const response = await axios.get(`${API_URL}/view-game`);
    //         setGames(response.data.game);
    //     } catch (error) {
    //         console.error("Error fetching games:", error);
    //     }
    // };


    const fetchGameTypesArray = async () => {
        try {
            const response = await axios.get(`${API_URL}/view-game-type`);

            setGame_types_array(response.data.gameType);
           // setIsLoading(false);
     
        } catch (error) {
            //setIsLoading(false);
            console.error("Error fetching games:", error);

        }
       
    };


    const fetchGameTypes = async (selectedGame, selectedGameLocation) => {

        try {
            const response = await axios.get(`${API_URL}/view-game-type-by-gameId/${selectedGame}/${selectedGameLocation}`);
            if (response.data.gameType) {
                setGame_types(response.data.gameType);
       
                const filteredGameType = response.data.gameType.filter(item => item.id === Number(selectedGameType));
            
    
                const minPlayers = filteredGameType[0].min_players;
                const maxPlayers = filteredGameType[0].max_players;
              
              setMinPlayers(minPlayers);
              setMaxPlayers(maxPlayers);
     
            }
            else {
                setGame_types([]);
            }



        } catch (error) {
            console.error("Error fetching games:", error);

        }
    };

    useEffect(() => {
        if (selectedGame && selectedGameLocation) {
            
        if (selectedPackageType === 'birthday_package') {
            fetchGamePackages(1);
        } 
        else if(selectedPackageType === 'corporate_event')
        {
            fetchCorporateEvents(2);
        }
        // else if(selectedPackageType === 'laser_tag_package'){
        //     fetchGameTypes(selectedGame, selectedGameLocation);
        // }
    }
    }, [selectedPackageType, selectedGame, selectedGameLocation]);

   

    const fetchGamePackages = async (selectedPackageType) => {

        try {
            const response = await axios.get(`${API_URL}/view-game-package-by-package/${selectedGameLocation}/${selectedGame}/${selectedPackageType}`);
     
            if (response.data.gamePackages) {
                setGame_packages(response.data.gamePackages);
       
            }
            else {
                setGame_packages([]);
            }
        } catch (error) {
            console.error("Error fetching package:", error);

        }
    };

    const fetchCorporateEvents = async (selectedPackageType) => {

        try {
            const response = await axios.get(`${API_URL}/view-corporate-event-by-package/${selectedGameLocation}/${selectedGame}/${selectedPackageType}`);
     
            if (response.data.corporateEvents) {
                setCorporate_events(response.data.corporateEvents);
       
            }
            else {
                setCorporate_events([]);
            }
        } catch (error) {
            console.error("Error fetching coperate event:", error);

        }
    };


    const handleGameChange = (e) => {
        const selectedGameId = e.target.value;
        setSelectedGame(selectedGameId);
    };



    useEffect(() => {

        if (selectedGame && selectedGameLocation) {
            fetchGameTypes(selectedGame, selectedGameLocation);
        }

    }, [selectedGame, selectedGameType, selectedGameLocation]);

   

    const handleGameTypeChange = (e) => {
        setAdults_count(0);
        setKids_count(0);
        setTimeSlotDetails({});
        setGrand_total(0);
        setHst(0);
        setAmount_paid(0);
        setDeposit_amount(0);
        setExtraGamePrice(0);
        setExtraPlayerPrice(0);
        setBasic_price(0);
        setBirthdayPrice({});
        setBooking_time([]);
        setBookingAvailableTimeSlots([]);
        setTotalPlayersErrorList('');
        setGameCountErrorList('');
        setBookingAvailableTimeSlots([]);
        setPayment_method('');
        setNote('');
        setTimeSlotDetails((prev) => ({ ...prev, price: 0 }));
        setBirthdayPrice((prev) => ({ ...prev, price: 0 }));
        setCorporatePrice((prev) => ({ ...prev, price: 0 }));
        const selectedGameTypeId = e.target.value;
        setSelectedGameType(selectedGameTypeId);
     
    };




    const handleBirthdayPackageChange = (e) => {
        const selectedBirthdayPackageId = e.target.value;
        setSelectedBirthdayPackage(selectedBirthdayPackageId);
        fetchOptionsForBirthdayPackage(selectedBirthdayPackageId);
        setFoodOptions([]);
        setDrinkOptions([]);
    };

    const handleCorporatePackageChange = (e) => {
        const selectedCorporatePackageId = e.target.value;
        setSelectedCorporatePackage(selectedCorporatePackageId);
        fetchOptionsForCorporatePackage(selectedCorporatePackageId);
        setEventFoodOptions([]);
        setEventDrinkOptions([]);
    };

    useEffect(() => {
     setSelectedFoods('');
     setSelectedDrinks('');
     setGame_count();
    }, [selectedBirthdayPackage]);

    useEffect(() => {
        setSelectedEventFoods('');
        setSelectedEventDrinks('');
        setEventGame_count();
       }, [selectedCorporatePackage]);

    const handleGameAvailableLocationChange = (e) => {
        const selectedGameLocationId = e.target.value;
        setSelectedGameLocation(selectedGameLocationId);
        fetchGameAvailable(selectedGameLocationId);
    };



    useEffect(() => {
        if (selectedPackageType || !selectedPackageType ) {
            // Reset counts to 0
            
            setAdults_count(0);
            setKids_count(0);
            setTimeSlotDetails({});
            setGrand_total(0);
            setHst(0);
            setDeposit_amount(0);
            setExtraGamePrice(0);
            setExtraPlayerPrice(0);
            setBasic_price(0);
            setAmount_paid(0);
            setBirthdayPrice({});
            setBooking_time([]);
            setTimeSlotDetails((prev) => ({ ...prev, price: 0 }));
            setBirthdayPrice((prev) => ({ ...prev, price: 0 }));
            setBookingAvailableTimeSlots([]);
            setTotalPlayersErrorList('');
            setGameCountErrorList('');
            setPayment_method('');
            setNote('');
            // Trigger recalculation
         
            // if (selectedGameType) {
            //     recalculateCosts();
            // } else if (selectedBirthdayPackage) {
            //     recalculateBirthdayCosts();
            // }
        }
    }, [selectedPackageType]);

    
   
    
    useEffect(() => {
        if(game_types.length){
            recalculateCosts();
        }
    
    }, [kids_count, adults_count, selectedGameType, booking_time, discountDetails, promoDetails]);
    
    useEffect(() => {
        if(game_packages.length)
            {
        recalculateBirthdayCosts();
            }
    }, [kids_count, adults_count, selectedBirthdayPackage, booking_time, discountDetails, promoDetails]);

    useEffect(() => {
        if(corporate_events.length)
            {
        recalculateCorporateCosts();
            }
    }, [kids_count, adults_count, selectedCorporatePackage, booking_time, discountDetails, promoDetails]);


    
    const recalculateCosts = () => {
         
        if (!isLoading && booking_time && selectedGameType) {

            const filteredGameType = game_types.filter(item => item.id === Number(selectedGameType));
            
            const adultsFirstPrice = filteredGameType[0].adults_first_price;
            const adultsSecondPrice = filteredGameType[0].adults_second_price;
            const adultsThirdPrice = filteredGameType[0].adults_third_price;

            // const adultsFirstPrice = timeSlotDetails.adults_first_price;
            // const adultsSecondPrice = timeSlotDetails.adults_second_price;
            // const adultsThirdPrice = timeSlotDetails.adults_third_price;


            const depositMethod = filteredGameType[0].deposit_method;
            const depositAmountPerPerson = parseFloat(filteredGameType[0].deposit_amount_per_person).toFixed(2);
            const depositPercentage = parseFloat(filteredGameType[0].deposit_percentage).toFixed(2);
            const minPlayers = filteredGameType[0].min_players;
            const maxPlayers = filteredGameType[0].max_players;
          
          setMinPlayers(minPlayers);
          setMaxPlayers(maxPlayers);

            let totalPrice = 0;
            let slotDetails = {};
          const totalPlayers = Number(kids_count) + Number(adults_count);
         
            if (booking_time.length === 1) {
                totalPrice = adultsFirstPrice * kids_count +
                adultsFirstPrice * adults_count;
             
                slotDetails[booking_time[0]] = {
                    time_slot: booking_time[0],
                    extra_game: 0,
                    extra_player:  0,
                    price_for_slot: adultsFirstPrice.toFixed(2),
                    total_players: totalPlayers,
                    row_total: (adultsFirstPrice * totalPlayers).toFixed(2),
                    no_games: 0,
                    is_min_game: 0
                };


            } else if (booking_time.length === 2) {
                totalPrice = (adultsFirstPrice * kids_count +
                    adultsFirstPrice * adults_count) +
                    (adultsSecondPrice * kids_count +
                        adultsSecondPrice* adults_count);

                        
            slotDetails[booking_time[0]] = {
                time_slot: booking_time[0],
                extra_game: 0,
                extra_player:  0,
                price_for_slot: adultsFirstPrice.toFixed(2),
                total_players: totalPlayers,
                row_total: (adultsFirstPrice * totalPlayers).toFixed(2),
                no_games: 0,
                is_min_game: 0
            };

            slotDetails[booking_time[1]] = {
                time_slot: booking_time[1],
                extra_game: 0,
                extra_player:  0,
                price_for_slot: adultsSecondPrice.toFixed(2),
                total_players: totalPlayers,
                row_total: (adultsSecondPrice * totalPlayers).toFixed(2),
                no_games: 0,
                is_min_game: 0
            };
                    
            } else if (booking_time.length >= 3) {
                const additionalSlots = booking_time.length - 2;
                totalPrice = (adultsFirstPrice * kids_count +
                    adultsFirstPrice * adults_count) +
                    (adultsSecondPrice * kids_count +
                        adultsSecondPrice * adults_count) +
                    (additionalSlots * (adultsThirdPrice * kids_count +
                        adultsThirdPrice * adults_count));


                        slotDetails[booking_time[0]] = {
                            time_slot: booking_time[0],
                            extra_game: 0,
                            extra_player:  0,
                            price_for_slot: adultsFirstPrice.toFixed(2),
                            total_players: totalPlayers,
                            row_total: (adultsFirstPrice * totalPlayers).toFixed(2),
                            no_games: 0,
                            is_min_game: 0
                        };
            
                        slotDetails[booking_time[1]] = {
                            time_slot: booking_time[1],
                            extra_game: 0,
                            extra_player:  0,
                            price_for_slot: adultsSecondPrice.toFixed(2),
                            total_players: totalPlayers,
                            row_total: (adultsSecondPrice * totalPlayers).toFixed(2),
                            no_games: 0,
                            is_min_game: 0
                        };
            
                        for (let i = 2; i < booking_time.length; i++) {
                            const priceForSlot = adultsThirdPrice;
                            const rowTotal = priceForSlot * totalPlayers;
            
                            slotDetails[booking_time[i]] = {
                                time_slot: booking_time[i],
                                extra_game: 0,
                                extra_player:  0,
                                price_for_slot: priceForSlot.toFixed(2),
                                total_players: totalPlayers,
                                row_total: rowTotal.toFixed(2),
                                no_games: 0,
                                is_min_game: 0
                            };
                        }
                    }
            
                    setCart_details(slotDetails);
      

            setTimeSlotDetails((prev) => ({ ...prev, price: totalPrice }));
            setSub_total(totalPrice);

   const adjustedTotalAmt = parseFloat(adjustedTotal || 0);
    const totalAfterAdjustment = totalPrice + adjustedTotalAmt;

let discountAmount = 0;
            

  if (discountDetails.length > 0) {
    discountDetails.forEach(discount => {
      if (discount.type === "percentage") {
        discountAmount += totalAfterAdjustment * (Number(discount.value) / 100);
      } else if (discount.type === "amount") {
        discountAmount += Number(discount.value);
      }
    });
   
  }

  let promoAmount = 0;

  if (promoDetails.length > 0) {
    promoDetails.forEach(promo => {
      if (promo.type === "percentage") {
        const percentageDiscount = totalAfterAdjustment * (Number(promo.value) / 100);
        promoAmount += percentageDiscount;
      } else if (promo.type === "amount") {
        promoAmount += Number(promo.value);
      }
    });
  }
  

  const totalDiscount = discountAmount + promoAmount;
  const cappedDiscount = Math.min(totalDiscount, totalAfterAdjustment);


  const discountedPrice = totalAfterAdjustment - cappedDiscount;


   setTotalBeforeHst(discountedPrice);

            const hst = (discountedPrice * 13) / 100;
             setHst(hst);

            // Calculate grand total
            const grandTotal = discountedPrice + hst;
            const formattedGrandTotal = parseFloat(grandTotal.toFixed(2));

            setGrand_total(formattedGrandTotal);


              // Calculate the deposit amount
        let depositInfo = '';
        let depositAmount = 0;
        if (depositMethod === 1) { // Amount per person
            depositAmount = depositAmountPerPerson * (Number(kids_count) + Number(adults_count))* booking_time.length ;
         
         depositInfo = `Deposit amount per person: ${depositAmountPerPerson} × Number of games: ${booking_time.length} × Total Number of Players: ${(Number(kids_count) + Number(adults_count))}`;
        } else if (depositMethod === 2) { // Percentage
            depositAmount = (totalPrice * depositPercentage) / 100;
            depositInfo = `${depositPercentage}% of Subtotal`;
        }
        setDeposit_amount(depositAmount);
        setAmount_paid(depositAmount);
        setDepositInfo(depositInfo);


        let depositDetails = '';
        if(depositMethod === 1)
        {
          depositDetails = 'Deposit amount per person : ' +depositAmountPerPerson;
          setDeposit_details(depositDetails);
        
        }
        else if (depositMethod === 2)
        {
           depositDetails = 'Deposit amount percentage : ' +depositPercentage;
           setDeposit_details(depositDetails);
    
        }

        // const cartDetails =  generateCartDetails(booking_time,priceForSlot);
        // setCart_details(cartDetails);
        // console.log(cartDetails);

        }
        

    }


    const recalculateBirthdayCosts = () => {
      
        if(!isLoading && booking_time  && selectedBirthdayPackage)
        {
       
            const filteredPackage = game_packages.filter(item => item.id === Number(selectedBirthdayPackage));
            const birthdayPrice = filteredPackage[0].price_per_game;
            const basicPrice= filteredPackage[0].basic_price;
            const depositAmt= filteredPackage[0].deposit_amount;
            const min_players =filteredPackage[0].min_players;
            const minGames = filteredPackage[0].min_games;
           
         
            let totalPrice = basicPrice;
            let slotDetails = {};
            const totalPlayers =  Number(kids_count) + Number(adults_count);

            const totalPlayersExcludingBirthdayKid = totalPlayers > 1 ? totalPlayers - 1 : 0; // Ensure the total doesn't go below 0
           
            const totalSlots = booking_time.length;
            const freeGames = 2; // Number of free games
    
            // // Calculate the number of paid slots
             const paidSlots = totalSlots > freeGames ? totalSlots - freeGames : 0;
            // const totalPriceForPaidSlots = birthdayPrice * totalPlayersExcludingBirthdayKid * paidSlots;
    
            // totalPrice += totalPriceForPaidSlots; // Add the calculated price

            const extraPlayers = Math.max(0, totalPlayers - min_players);

        
            
        if (totalSlots > 0) {
           
            const extraPlayerCostForBaseGames = extraPlayers * minGames * birthdayPrice;

            setExtraPlayerPrice(extraPlayerCostForBaseGames);
            const additionalPaidGames = Math.max(0, totalSlots - (minGames + freeGames));
            const extraGameCost = totalPlayersExcludingBirthdayKid * additionalPaidGames * birthdayPrice;
            setExtraGamePrice(extraGameCost);

            totalPrice += extraPlayerCostForBaseGames + extraGameCost;


       
            // Populate slot details
            // for (let i = 0; i < totalSlots; i++) {
              //  const timeSlot = booking_time[i];

              //  const isInitialSelection = initialSelectionSlots.includes(timeSlot); // Checks if it's within the initial selected slots
           
                let firstTime = initialSelectionSlots[0]?.split(" - ")[0]; // Start time of first slot
                let lastTime = initialSelectionSlots[minGames + freeGames - 1]?.split(" - ")[1]; // End time of last slot
                
                // Merge them into a single time slot
                let mergedTimeSlots = `${firstTime} - ${lastTime}`;

                // let mergedTimeSlots =  booking_time.filter((timeSlot) => {
                //     return initialSelectionSlots.includes(timeSlot); // Only keep slots that were NOT part of the base package
                // });
                
                
                // console.log(mergedTimeSlots);
                

                    slotDetails[mergedTimeSlots] = {
                        time_slot: mergedTimeSlots,
                        extra_player: 0, // Base slot has no extra players initially
                        extra_game: 0,   // Base slot has no extra games initially
                    // price_for_slot: i < freeGames ? 0 : birthdayPrice.toFixed(2),
                        price_for_slot: 0,
                        total_players: totalPlayers - totalPlayersExcludingBirthdayKid,
                    //   row_total: i < freeGames ? '0.00' : (birthdayPrice * totalPlayersExcludingBirthdayKid).toFixed(2),
                        row_total:basicPrice,
                    // no_games: freeGames ? 0 : 1,
                       no_games: minGames,
                       
                    // min_games: isInitialSelection ? 1 : 0,
                        is_min_game: 1,
                
                    };

                    if (totalPlayers > min_players) {
                        slotDetails["extra_player_price"] = {
                            time_slot: mergedTimeSlots,
                            extra_player: totalPlayers - totalPlayersExcludingBirthdayKid,
                            extra_game: 0,
                            price_for_slot: birthdayPrice.toFixed(2),
                            total_players: totalPlayers - min_players,
                            row_total: (extraPlayers * minGames * birthdayPrice).toFixed(2),
                            no_games: minGames.toString(),
                            is_min_game: 1,
                        };
                    }

                    const extraGameSlots = booking_time.filter((timeSlot) => {
                        return !initialSelectionSlots.includes(timeSlot); // Only keep slots that were NOT part of the base package
                    });
                    

                    extraGameSlots.forEach((extraGameSlot, index) => {
                        slotDetails[extraGameSlot] = {
                            time_slot: extraGameSlot,
                            //extra_player:  totalPlayers - totalPlayersExcludingBirthdayKid,
                            extra_player:  0,
                            extra_game: 1,
                            price_for_slot: birthdayPrice.toFixed(2),
                            total_players: totalPlayersExcludingBirthdayKid,
                            row_total: (totalPlayersExcludingBirthdayKid * birthdayPrice).toFixed(2),
                            //no_games:(freeGames + minGames) + index,
                            no_games:1,
                            is_min_game: 0,
                        };
                    });
                
                        setCart_details(slotDetails);
            
             }
            

            setBirthdayPrice((prev) => ({ ...prev, price: totalPrice }));
            setSub_total(totalPrice);

         const adjustedTotalAmt = parseFloat(adjustedTotal || 0);
        const totalAfterAdjustment = totalPrice + adjustedTotalAmt;

             let discountAmount = 0;
            

            if (discountDetails.length > 0) {
              discountDetails.forEach(discount => {
                if (discount.type === "percentage") {
                  discountAmount += totalAfterAdjustment * (Number(discount.value) / 100);
                } else if (discount.type === "amount") {
                  discountAmount += Number(discount.value);
                }
              });
             
            }
          
            let promoAmount = 0;
          
            if (promoDetails.length > 0) {
              promoDetails.forEach(promo => {
                if (promo.type === "percentage") {
                  const percentageDiscount = totalAfterAdjustment * (Number(promo.value) / 100);
                  promoAmount += percentageDiscount;
                } else if (promo.type === "amount") {
                  promoAmount += Number(promo.value);
                }
              });
            }
            
          
            const totalDiscount = discountAmount + promoAmount;
            const cappedDiscount = Math.min(totalDiscount, totalAfterAdjustment);
          
          
            const discountedPrice = totalAfterAdjustment - cappedDiscount;
         setTotalBeforeHst(discountedPrice);

        const hst = (discountedPrice * 13) / 100;
        setHst(hst);

        const grandTotal = discountedPrice + hst;
        const formattedGrandTotal = parseFloat(grandTotal.toFixed(2));


        setGrand_total(formattedGrandTotal);

        const calculatedDeposit = (totalPrice * 50) / 100;
        const calculatedDepositInfo = '50% of Subtotal'
       setDeposit_amount(calculatedDeposit.toFixed(2));
       setDepositInfo(calculatedDepositInfo);
      //  setDeposit_amount(depositAmt);
 

        setAmount_paid(calculatedDeposit.toFixed(2));
        setBasic_price(basicPrice);
     
            if(selectedBirthdayPackage && birthday_packages.min_games)  
        { 
            setMin_game(birthday_packages.min_games);
          
        }

        let depositDetails = '';
          depositDetails = 'Package basic price : ' +depositAmt;
          setDeposit_details(depositDetails);

        //   const cartDetails =  generateCartDetails(booking_time, priceForSlot);
        //   setCart_details(cartDetails);

        }
    }

   
    const recalculateCorporateCosts = () => {
    
        if(!isLoading && booking_time  && selectedCorporatePackage)
        {
       
            const filteredPackage = corporate_events.filter(item => item.id === Number(selectedCorporatePackage));
            const corporatePrice = filteredPackage[0].price_per_game;
            const basicPrice= filteredPackage[0].basic_price;
            const depositAmt= filteredPackage[0].deposit_amount;
            const min_players =filteredPackage[0].min_players;
            const minGames = filteredPackage[0].min_games;

          

            let totalPrice = basicPrice;
            let slotDetails = {};
            const totalPlayers =  Number(kids_count) + Number(adults_count);

            const totalPlayersExcludingBirthdayKid = totalPlayers > 1 ? totalPlayers - 1 : 0; // Ensure the total doesn't go below 0
           
            const totalSlots = booking_time.length;
            const freeGames = 2; // Number of free games
    
            // // Calculate the number of paid slots
            // const paidSlots = totalSlots > freeGames ? totalSlots - freeGames : 0;
            // const totalPriceForPaidSlots = corporatePrice * totalPlayers * paidSlots;
    
            // totalPrice += totalPriceForPaidSlots; // Add the calculated price

            const extraPlayers = Math.max(0, totalPlayers - min_players);
            if (totalSlots > 0) {
                // Extra players beyond the package limit
           
                const extraPlayerCostForBaseGames = extraPlayers * minGames * corporatePrice; // 3 extra players × 3 games × $10
                setExtraPlayerPrice(extraPlayerCostForBaseGames);
                // Extra game cost (beyond the 3 package games + 2 free games)
                const additionalPaidGames = Math.max(0, totalSlots - (minGames + freeGames)); 
                const extraGameCost = totalPlayersExcludingBirthdayKid * additionalPaidGames * corporatePrice;
                setExtraGamePrice(extraGameCost);
                // Add extra player & extra game costs only after slot selection
                totalPrice += extraPlayerCostForBaseGames + extraGameCost;
            

             


        
            // Populate slot details
           // for (let i = 0; i < totalSlots; i++) {
                ///const timeSlot = booking_time[i];

               // const isInitialSelection = corporateInitialSelectionSlots.includes(timeSlot); // Checks if it's within the initial selected slots


                let firstTime = corporateInitialSelectionSlots[0]?.split(" - ")[0]; // Start time of first slot
//                let firstTime = '';
// if (initialSelectionSlots && initialSelectionSlots[0]) {
//     firstTime = initialSelectionSlots[0].split(" - ")[0]; // Start time of first slot
// } else {
//     console.error("Initial selection slots are not properly defined.");
// }
               
               
               let lastTime = corporateInitialSelectionSlots[minGames + freeGames - 1]?.split(" - ")[1]; // End time of last slot
               
               // Merge them into a single time slot
               let mergedTimeSlots = `${firstTime} - ${lastTime}`;
              
             // console.log(mergedTimeSlots);
             

                slotDetails[mergedTimeSlots] = {
                    time_slot: mergedTimeSlots,
                    extra_player: 0, // Base slot has no extra players initially
                    extra_game: 0,   // Base slot has no extra games initially
                   // price_for_slot: i < freeGames ? 0 : birthdayPrice.toFixed(2),
                    price_for_slot: 0,
                    total_players: totalPlayers - totalPlayersExcludingBirthdayKid,
                 //   row_total: i < freeGames ? '0.00' : (birthdayPrice * totalPlayersExcludingBirthdayKid).toFixed(2),
                   row_total:basicPrice,
                  // no_games: freeGames ? 0 : 1,
                  no_games: minGames,
                   // min_games: isInitialSelection ? 1 : 0,
                    is_min_game: 1,
               
                };

                if (totalPlayers > min_players) {
                    slotDetails["extra_player_price"] = {
                        time_slot: mergedTimeSlots,
                        extra_player: totalPlayers - totalPlayersExcludingBirthdayKid,
                        extra_game: 0,
                        price_for_slot: corporatePrice.toFixed(2),
                        total_players: totalPlayers - min_players,
                        row_total: (extraPlayers * minGames * corporatePrice).toFixed(2),
                        no_games: minGames.toString(),
                        is_min_game: 1,
                    };
                }

                const extraGameSlots = booking_time.filter((timeSlot) => {
                    return !corporateInitialSelectionSlots.includes(timeSlot); // Only keep slots that were NOT part of the base package
                });
                

                extraGameSlots.forEach((extraGameSlot, index) => {
                    slotDetails[extraGameSlot] = {
                        time_slot: extraGameSlot,
                        //extra_player:  totalPlayers - totalPlayersExcludingBirthdayKid,
                        extra_player:  0,
                        extra_game: 1,
                        price_for_slot: corporatePrice.toFixed(2),
                        total_players: totalPlayersExcludingBirthdayKid,
                        row_total: (totalPlayersExcludingBirthdayKid * corporatePrice).toFixed(2),
                        //no_games:(freeGames + minGames) + index,
                        no_games:1,
                        is_min_game: 0,
                    };
                });
        
            
          
                        setCart_details(slotDetails);
            
            
        }

            setCorporatePrice((prev) => ({ ...prev, price: totalPrice }));
            setSub_total(totalPrice);

const adjustedTotalAmt = parseFloat(adjustedTotal || 0);
const totalAfterAdjustment = totalPrice + adjustedTotalAmt;



             let discountAmount = 0;
            

            if (discountDetails.length > 0) {
              discountDetails.forEach(discount => {
                if (discount.type === "percentage") {
                  discountAmount += totalAfterAdjustment * (Number(discount.value) / 100);
                } else if (discount.type === "amount") {
                  discountAmount += Number(discount.value);
                }
              });
             
            }
          
            let promoAmount = 0;
          
            if (promoDetails.length > 0) {
              promoDetails.forEach(promo => {
                if (promo.type === "percentage") {
                  const percentageDiscount = totalAfterAdjustment * (Number(promo.value) / 100);
                  promoAmount += percentageDiscount;
                } else if (promo.type === "amount") {
                  promoAmount += Number(promo.value);
                }
              });
            }
            
          
            const totalDiscount = discountAmount + promoAmount;
            const cappedDiscount = Math.min(totalDiscount, totalAfterAdjustment);
          
          
            const discountedPrice = totalAfterAdjustment - cappedDiscount;

          setTotalBeforeHst(discountedPrice);

        const hst = (discountedPrice * 13) / 100;
        setHst(hst);

        const grandTotal = discountedPrice + hst;
        const formattedGrandTotal = parseFloat(grandTotal.toFixed(2));


        setGrand_total(formattedGrandTotal);

        const calculatedDeposit = (totalPrice * 50) / 100;
        setDeposit_amount(calculatedDeposit.toFixed(2));
      //  setDeposit_amount(depositAmt);
 

        setAmount_paid(calculatedDeposit.toFixed(2));
     
        setBasic_price(basicPrice);
     
            if(selectedCorporatePackage && corporate_packages.min_games)  
        { 
            setMin_game(corporate_packages.min_games);
          
        }

        let depositDetails = '';
          depositDetails = 'Package basic price : ' +depositAmt;
          setDeposit_details(depositDetails);

        //   const cartDetails =  generateCartDetails(booking_time, priceForSlot);
        //   setCart_details(cartDetails);

        }
    }

 


    const calculateTimeSlots = (startTime, endTime, interval) => {
        const timeSlots = [];
        const [startHour, startMinute] = parseTime(startTime);
        const [endHour, endMinute] = parseTime(endTime);

        let current = new Date();
        current.setHours(startHour, startMinute, 0, 0);

        const end = new Date();
        end.setHours(endHour, endMinute, 0, 0);

        while (current <= end) {
            const timeSlot = current.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });
            timeSlots.push(timeSlot);
            current.setMinutes(current.getMinutes() + interval);
        }

        return timeSlots;
    };


    const parseTime = (timeString) => {
        const [time, period] = timeString.split(' ');
        const [hours, minutes] = time.split(':').map(Number);
        const adjustedHours = period === 'PM' && hours !== 12 ? hours + 12 : hours;
        return [adjustedHours, minutes];
    };

   

    const handleBookingDateChange = (selectedDate) => {
        let errors = {};
        if (!selectedGameLocation) {
            errors.location_id = "Please select a game location.";
        }

        if (!selectedGame) {
            errors.game_id = "Please select a game.";
        }


        if (Object.keys(errors).length > 0) {
            setErrorList(errors);
            return;
        }

        // setIsLoading(true);
        resetBooking();

        if (selectedGameLocation && selectedGame) {
            setBooking_date(selectedDate);
            setSelectedDate(selectedDate);
            setView('form');
        }
        // setIsLoading(false);

    };

    const spaceDisabledSlots = bookingAvailableTimeSlots
    .filter((timeSlot, index) => {
        const game_type = game_types_array.find(item => item.id.toString() === selectedGameType);
        const maxPlayers = game_packages?.[0]?.max_players_in_a_slot || 0; // Use 0 or a default value if undefined
        const remainingSpace = availableSpaces[timeSlot] || 0;
        const isBooked = customerById?.booking_time?.includes(timeSlot);

        // For birthday package, check if remaining space doesn't match the max player requirement
        if (selectedPackageType === 'birthday_package' && remainingSpace !== maxPlayers  && !isBooked
        ) {
            return true; // This slot should be disabled
        }
        return false;
    });

    const spaceDisabledSlotsCorporate = bookingAvailableTimeSlots
    .filter((timeSlot, index) => {
        const game_type = game_types_array.find(item => item.id.toString() === selectedGameType);
        const maxPlayers = corporate_events[0]?.max_players_in_a_slot;
        const remainingSpace = availableSpaces[timeSlot] || 0;
        const isBooked = booking_time?.includes(timeSlot);
        // For birthday package, check if remaining space doesn't match the max player requirement
        if (selectedPackageType === 'corporate_event' && remainingSpace !== maxPlayers  && !isBooked
        ) {
            return true; // This slot should be disabled
        }
        return false;
    });


    const handleTimeSlotChange = (event) => {
        const selectedTimeSlot = event.target.value;
        const selectedSlotIndex = bookingAvailableTimeSlots.indexOf(selectedTimeSlot);

        if (selectedPackageType === 'birthday_package') {
            
                const userGameCount = parseInt(game_count, 10); // Get the number of games selected by the user
                const totalSlotsToSelect = userGameCount + 2; // Add 2 free games

                const nextSlots = bookingAvailableTimeSlots.slice(selectedSlotIndex, selectedSlotIndex + totalSlotsToSelect);


                if (!initialSelectionDone) {

                    const hasConflict = nextSlots.length !== totalSlotsToSelect ||
                    nextSlots.some(slot =>{
                 const isSlotBooked = customerById?.booking_time?.includes(slot);
                    return (
                    !isSlotBooked && 
                        disabledTimeSlots.includes(slot)) || spaceDisabledSlots.includes(slot);
                });


                
         
                    if (hasConflict) {
                        alert('Please choose a different start time as this start time won’t allow for 2.5 hours.');
                        return; // Exit without making changes
                    }
                    // Set the consecutive slots for the first time
                    setBooking_time(nextSlots); // Clear all previous selections and set only the new consecutive slots
                    setInitialSelectionDone(true); // Mark the initial selection as done
                    setInitialSelectionSlots(nextSlots);
                } else {
                    // Allow single slot selection after the initial consecutive slots have been selected
                    setBooking_time((prevBookingTime) => {
                        let newBookingTime = [...prevBookingTime];
        
                        
                if (initialSelectionSlots.includes(selectedTimeSlot)) {
                    newBookingTime = []; // Clear all selections
                    setInitialSelectionDone(false); // Reset the initial selection state
                    setInitialSelectionSlots([]); // Clear the initial selection slots
                } else if (prevBookingTime.includes(selectedTimeSlot)) {
                    // If the time slot is already selected, unselect it (independent slot)
                    newBookingTime = newBookingTime.filter(slot => slot !== selectedTimeSlot);
                // } else {
                //     // If the time slot is not selected, select it (independent slot)
                //     newBookingTime.push(selectedTimeSlot);
                // }

            } else {
                const firstSelectedSlot = newBookingTime[0];
                const lastSelectedSlot = newBookingTime[newBookingTime.length - 1];
                const firstSelectedIndex = bookingAvailableTimeSlots.indexOf(firstSelectedSlot);
                const lastSelectedIndex = bookingAvailableTimeSlots.indexOf(lastSelectedSlot);

                if (selectedSlotIndex === firstSelectedIndex - 1 || selectedSlotIndex === lastSelectedIndex + 1) {
                    newBookingTime.push(selectedTimeSlot);
                    newBookingTime.sort((a, b) => bookingAvailableTimeSlots.indexOf(a) - bookingAvailableTimeSlots.indexOf(b));
                } else {
                    alert("Please select consecutive time slots.");
                }
            }
                        return newBookingTime;
                    });
                }
            }

else  if (selectedPackageType === 'corporate_event') {
            
    const userGameCount = parseInt(eventGame_count, 10); // Get the number of games selected by the user
    const totalSlotsToSelect = userGameCount + 2; // Add 2 free games

    const nextSlots = bookingAvailableTimeSlots.slice(selectedSlotIndex, selectedSlotIndex + totalSlotsToSelect);
    


    if (!corporateInitialSelectionDone) {

        const hasConflict = nextSlots.length !== totalSlotsToSelect ||
        nextSlots.some(slot =>  {
                     const isSlotBooked = booking_time?.includes(slot);
                    return (
                         !isSlotBooked && 
                        disabledTimeSlots.includes(slot)) || spaceDisabledSlotsCorporate.includes(slot)
      });
        if (hasConflict) {
            alert('Please choose a different start time as this start time won’t allow for 2.5 hours.');
            return; // Exit without making changes
        }
        // Set the consecutive slots for the first time
        setBooking_time(nextSlots); // Clear all previous selections and set only the new consecutive slots
        setCorporateInitialSelectionDone(true); // Mark the initial selection as done
        setCorporateInitialSelectionSlots(nextSlots);
    } else {
        // Allow single slot selection after the initial consecutive slots have been selected
        setBooking_time((prevBookingTime) => {
            let newBookingTime = [...prevBookingTime];

            
    if (corporateInitialSelectionSlots.includes(selectedTimeSlot)) {
        newBookingTime = []; // Clear all selections
        setCorporateInitialSelectionDone(false); // Reset the initial selection state
        setCorporateInitialSelectionSlots([]); // Clear the initial selection slots
    } else if (prevBookingTime.includes(selectedTimeSlot)) {
        // If the time slot is already selected, unselect it (independent slot)
        newBookingTime = newBookingTime.filter(slot => slot !== selectedTimeSlot);
    }
    //  else {
    //     // If the time slot is not selected, select it (independent slot)
    //     newBookingTime.push(selectedTimeSlot);
    // }

    else {
        const firstSelectedSlot = newBookingTime[0];
        const lastSelectedSlot = newBookingTime[newBookingTime.length - 1];
        const firstSelectedIndex = bookingAvailableTimeSlots.indexOf(firstSelectedSlot);
        const lastSelectedIndex = bookingAvailableTimeSlots.indexOf(lastSelectedSlot);

        if (selectedSlotIndex === firstSelectedIndex - 1 || selectedSlotIndex === lastSelectedIndex + 1) {
            newBookingTime.push(selectedTimeSlot);
            newBookingTime.sort((a, b) => bookingAvailableTimeSlots.indexOf(a) - bookingAvailableTimeSlots.indexOf(b));
        } else {
            alert("Please select consecutive time slots.");
        }
    }
            return newBookingTime;
        });
    }
}

            else{


                
                
        // setBooking_time((prevBookingTime) =>
        //     prevBookingTime.includes(selectedTimeSlot)
        //         ? prevBookingTime.filter((timeSlot) => timeSlot !== selectedTimeSlot)
        //         : [...prevBookingTime, selectedTimeSlot]
        // );


        setBooking_time((prevBookingTime) => {
            let newBookingTime = [...(prevBookingTime || [])]; // Ensure it's an array
        
            if (newBookingTime.includes(selectedTimeSlot)) {
                // If the time slot is already selected, unselect it
                newBookingTime = newBookingTime.filter(slot => slot !== selectedTimeSlot);
            } else {
                // Check if the new selection is consecutive
                if (newBookingTime.length === 0) {
                    // Allow first selection freely
                    newBookingTime.push(selectedTimeSlot);
                } else {
                    const firstSelectedSlot = newBookingTime[0];
                    const lastSelectedSlot = newBookingTime[newBookingTime.length - 1];
                    const firstSelectedIndex = bookingAvailableTimeSlots.indexOf(firstSelectedSlot);
                    const lastSelectedIndex = bookingAvailableTimeSlots.indexOf(lastSelectedSlot);
        
                    if (selectedSlotIndex === firstSelectedIndex - 1 || selectedSlotIndex === lastSelectedIndex + 1) {
                        // Allow only consecutive slot selection
                        newBookingTime.push(selectedTimeSlot);
                        newBookingTime.sort((a, b) => bookingAvailableTimeSlots.indexOf(a) - bookingAvailableTimeSlots.indexOf(b));
                    } else {
                        alert("Please select consecutive time slots.");
                    }
                }
            }
        
            return newBookingTime; // Return updated array
        });

            }

    };

    async function updateBooking(e) {
        e.preventDefault();
        setLoading(true);


        let errors = {}; 
        if (selectedBirthdayPackage) {
            if (Number(getTotalSelectedFoods()) < Number(birthday_packages.food_quantity)) {
                errors.food_details = `Please select ${birthday_packages.food_quantity} food options.`;
            }
            if (Number(getTotalSelectedDrinks()) < Number(birthday_packages.drink_quantity)) {
                errors.drink_details = `Please select ${birthday_packages.drink_quantity} drink options.`;
            }
        }
    
        if (selectedCorporatePackage) {
            if (Number(getTotalSelectedFoods()) < Number(corporate_packages.food_quantity)) {
                errors.food_details = `Please select ${corporate_packages.food_quantity} food options.`;
            }
            if (Number(getTotalSelectedDrinks()) < Number(corporate_packages.drink_quantity)) {
                errors.drink_details = `Please select ${corporate_packages.drink_quantity} drink options.`;
            }
        }
    
        if (Object.keys(errors).length > 0) {
            setBookingErrorList(errors); // Overwrite previous errors
            setLoading(false);
            return;
        } else {
            setBookingErrorList({}); // Clear errors if validation passes
        }
    
   
        const sendEmailNotification = document.getElementById('sendNotificationCheckbox').checked;
    
        try {
            const formData = new FormData();

            formData.append("location_id", selectedGameLocation);
            formData.append("game_id", selectedGame);
            formData.append("game_type_id", selectedGameType);
            formData.append("booked_date", booking_date);
            formData.append("booked_time", JSON.stringify(booking_time));
            formData.append("booked_by", userContext.userDetails.id);
            formData.append("firstname", firstname);
            formData.append("lastname", lastname);
            formData.append("phone", phone);
            formData.append("email", email);
            formData.append("no_of_adults", adults_count);
            formData.append("no_of_children", kids_count);
            formData.append("hst", hst);
            formData.append("grand_total", grand_total);
            formData.append("payment_due", grand_total - amount_paid); // Add due amount
            formData.append("deposit_amount", deposit_amount);
            formData.append("deposit_details", deposit_details);
            formData.append("no_of_slots", booking_time.length);
            formData.append("cart_details", JSON.stringify(cart_details));
            formData.append("amount_paid", amount_paid);
            formData.append("selectedPackageType", selectedPackageType);
            formData.append("selectedGameType", selectedGameType);
            formData.append("selectedBirthdayPackage", selectedBirthdayPackage);
            formData.append("selectedCorporatePackage", selectedCorporatePackage);
            formData.append("min_players", minPlayers);
            formData.append("max_players", maxPlayers);
            formData.append("total_players", Number(adults_count) + Number(kids_count));
            formData.append("payment_method", payment_method);
            formData.append('note', note ? note : '');
            formData.append("discount_details", JSON.stringify(discountDetails));
            formData.append("discount_amount", Number(discountAmount) || 0);
            formData.append("promo_details", JSON.stringify(promoDetails));
            formData.append("promo_amount", Number(promoAmount) || 0);
  

            if (selectedBirthdayPackage) {
                formData.append("is_package", 1);
                formData.append("main_package_id", 1);
                formData.append("sub_package_id", selectedBirthdayPackage);
                formData.append("package_price", basic_price);
                formData.append("game_package_id", selectedBirthdayPackage);
                formData.append("birthday_kid_name", birthdayKid? birthdayKid: '');

                // formData.append("food_details", selectedFoods);

                const formattedEventFoods = {};
                const formattedEventDrinks = {};
// Loop through selected foods and format them into an object
Object.entries(selectedFoods).forEach(([food, quantity]) => {
    if (quantity > 0) {  // Only append foods that have been selected
      formattedEventFoods[food] = String(quantity); // Convert quantity to string to ensure it's saved as string
    }
  });


  Object.entries(selectedDrinks).forEach(([drink, quantity]) => {
    if (quantity > 0) { 
      formattedEventDrinks[drink] = String(quantity); 
    }
  });

  // Prepare form data for submission

  formData.append("food_details", JSON.stringify(formattedEventFoods)); // Now storing as a proper JSON object
  formData.append("drink_details", JSON.stringify(formattedEventDrinks)); // Same here for drinks

        
               
                // formData.append("drink_details", selectedDrinks);
                formData.append("game_count", game_count);
                formData.append("min_game", min_game);
                formData.append("max_players_in_a_slot", birthday_packages.max_players_in_a_slot);
                formData.append("cost", birthdayPrice.price);
                formData.append("subtotal", birthdayPrice.price);
                formData.append("extraPlayerPrice", extraPlayerPrice);
                formData.append("extraGamePrice", extraGamePrice);
                } else  if (selectedCorporatePackage) {
                formData.append("is_package", 1);
                formData.append("main_package_id", 2);
                formData.append("sub_package_id", selectedCorporatePackage);
                formData.append("package_price", basic_price);
                formData.append("corporate_package_id", selectedCorporatePackage);

                const formattedEventFoods = {};
                const formattedEventDrinks = {};
Object.entries(selectedFoods).forEach(([food, quantity]) => {
    if (quantity > 0) {  
      formattedEventFoods[food] = String(quantity);
    }
  });

  // Loop through selected drinks and format them into an object
  Object.entries(selectedDrinks).forEach(([drink, quantity]) => {
    if (quantity > 0) {  // Only append drinks that have been selected
      formattedEventDrinks[drink] = String(quantity); // Convert quantity to string
    }
  });

  // Prepare form data for submission

  formData.append("food_details", JSON.stringify(formattedEventFoods)); // Now storing as a proper JSON object
  formData.append("drink_details", JSON.stringify(formattedEventDrinks)); // Same here for drinks

     
                formData.append("game_count", eventGame_count);
                formData.append("min_game", min_game);
                formData.append("max_players_in_a_slot", corporate_packages.max_players_in_a_slot);
                formData.append("cost", corporatePrice.price);
                formData.append("subtotal", corporatePrice.price);
                formData.append("extraPlayerPrice", extraPlayerPrice);
                formData.append("extraGamePrice", extraGamePrice);
        

            } 
            
            else {
                formData.append("cost", sub_total);
                formData.append("subtotal", sub_total);
                formData.append("food_details", JSON.stringify({})); // Empty object if no food details
                formData.append("drink_details", JSON.stringify({})); // Empty object if no drink details

            }
    

            // for (let pair of formData.entries()) {
            //     console.log(pair[0] + ": " + pair[1]);
            // }
        
         
            const bookingResponse = await axios.post(`${API_URL}/edit-booked-slots/${booking_id}`, formData);
            if (sendEmailNotification) {
            
             const emailData = await prepareEmailData(bookingResponse.data.booking);
    

       
             const emailResponse = await axios.post(`${API_URL}/send-email`, emailData);

            }
    
            Swal.fire({
                icon: "success",
                // text: emailResponse.data.message
                text: 'Updated Successfully!!'
            });

          navigate('/booking-details/'+booking_id);   
            resetBooking();
           // fetchEvents();
            setBookingErrorList([]);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (error) {
            setBookingErrorList(error.response?.data?.validate_err || []);
            Swal.fire({
                text: error.response?.data?.message || 'Something went wrong!',
                icon: "error"
            });
            console.error('Full error:', error);

        } finally {
            setLoading(false);
        }
    }
    


    const formatBookedTime = (bookedTime) => {
        try {
          const timeSlots = JSON.parse(bookedTime); // Assuming bookedTime is a JSON string
          if (Array.isArray(timeSlots) && timeSlots.length > 0) {
            
            // Sort time slots by start time before merging
            const sortedSlots = timeSlots.sort((a, b) => {
              const [startA] = a.split(' - ');
              const [startB] = b.split(' - ');
              return moment(startA, 'hh:mm A').diff(moment(startB, 'hh:mm A'));
            });
      
            let mergedSlots = [];
            let currentRangeStart = null;
            let currentRangeEnd = null;
      
            sortedSlots.forEach((slot, index) => {
              const [startTime, endTime] = slot.split(' - ');
              const currentStartTime = moment(startTime, 'hh:mm A');
              const currentEndTime = moment(endTime, 'hh:mm A');
      
              if (!currentRangeStart) {
                // First time slot, initialize the range
                currentRangeStart = currentStartTime;
                currentRangeEnd = currentEndTime;
              } else if (currentRangeEnd.isSame(currentStartTime)) {
                // If the current slot starts when the last one ended, extend the range
                currentRangeEnd = currentEndTime;
              } else {
                // If the current slot does not continue from the last one, close the current range and start a new one
                mergedSlots.push(`${currentRangeStart.format('h:mm A')} - ${currentRangeEnd.format('h:mm A')}`);
                currentRangeStart = currentStartTime;
                currentRangeEnd = currentEndTime;
              }
      
              // If it's the last slot, push the current range
              if (index === sortedSlots.length - 1) {
                mergedSlots.push(`${currentRangeStart.format('h:mm A')} - ${currentRangeEnd.format('h:mm A')}`);
              }
            });
      
            return mergedSlots.join(', '); // Join the merged slots with a comma
          }
          return 'No time slots available';
        } catch (error) {
          //console.error("Error parsing booked time:", error);
          return 'Invalid time format';
        }
      };
      


    function convertPlainTextToHTML(text) {
        return text
            .replace(/\n/g, '<br>')  // Replace line breaks with <br>
            .replace(/ {2,}/g, match => '&nbsp;'.repeat(match.length));  // Replace multiple spaces with &nbsp;
    }

    async function prepareEmailData(bookingDetails) {

        
        const consentFormUrl = `${API_BASE_URL}/consent-form-page/${bookingDetails.booking_ref_id}/${bookingDetails.booking_id}`;
        const formattedBookedTime = formatBookedTime(bookingDetails.booked_time);

        const qrCodeFilename = `${bookingDetails.booking_ref_id}.png`; // Use the same filename for consistency

        // Generate and upload QR code image
      
        const qrCodeImageUrl = `${LARAVEL_API_URL}/uploads/qrImages/${qrCodeFilename}`;
    
        // Convert the plain text template to HTML
        let message = convertPlainTextToHTML(emailData.message)
            .replace('[customer_name]', `${bookingDetails.firstname} ${bookingDetails.lastname}`)
            .replace('[event_date]', moment(bookingDetails.booked_date).format('D MMMM YYYY'))
            .replace('[event_time]', formattedBookedTime)  // Joining the times array into a string
            .replace('[location]', bookingDetails.location_name)
            .replace('[number_of_players]', bookingDetails.total_players)
            .replace('[package_name]',  bookingDetails.game_type_name ||
                (bookingDetails.package_name === 'Corporate' 
                  ? `${bookingDetails.package_name} - ${bookingDetails.corporate_package_name}`
                  : `${bookingDetails.package_name} - ${bookingDetails.game_package_name}`
                ))
            .replace('[consent_form_link]', `<a href="${consentFormUrl}">Click here to complete the consent form</a>`)
            .replace('[qr_code]', qrCodeImageUrl ? `<img src="${qrCodeImageUrl}" alt="QR Code for Consent Form" />` : 'QR code not available');
         
            if (bookingDetails.note && bookingDetails.note.trim() !== "") {
                message = message.replace("[note]", bookingDetails.note.trim());
              } else {
                message = message.replace(/.*Note\s*:\s*\[note\]\s*\n?/gi, "");
              }

        return {
            booking_id: bookingDetails.booking_id,
            to: bookingDetails.email,
            subject: emailData.subject,
            message ,
            bcc: 'booking.lasercombat@hotmail.com', 
        };
    }
    
    function generateQRCodeDataUrl(url) {
        // Return a promise that resolves with the QR code Data URL
     
        return QRCode.toDataURL(url, { width: 150 });
    }

    async function generateQRCodeImage(url, filename,size = 150) {
        try {
            // Generate QR Code as Data URL
            const dataUrl = await QRCode.toDataURL(url,  { width: size, height: size });
    
            // Convert Data URL to Blob
            const blob = await (await fetch(dataUrl)).blob();
            
            // Upload Blob to your server and get the URL
            const imageUrl = await uploadQRCodeImage(blob, filename);
            
           
            return imageUrl;
        } catch (error) {
            console.error('Error generating QR code image:', error);
            return null;
        }
    }
    
    async function uploadQRCodeImage(blob, filename) {
        const formData = new FormData();
        formData.append('file', blob, filename);
    
        try {
            const response = await axios.post(`${API_URL}/upload-qr-code`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    
            if (response.status !== 200) {
                throw new Error('Failed to upload QR code image');
            }
    
            const result = response.data; 
           
            return result.imageUrl;         
        } catch (error) {
            console.error('Error uploading QR code image:', error);
            return null;
        }
    }




    const handleCloseEmailModal = () => setShowEmailModal(false);

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setEmailData(prevData => ({ ...prevData, [name]: value }));
  };

//   const handleSubmit = (e) => {
//       e.preventDefault();
//       setLoading(true);

//       const formData = {        
//           ...emailData,
//       };
//       // Implement email sending functionality here
//     //   console.log('Email sent with data:', formData);
    
//         axios.post(`${API_URL}/send-email`, formData)
//         .then(() => {
    
//          setLoading(false);
//          showToast("Email sent successfully!");
//          handleCloseEmailModal();
//        //  setEmailErrorList({ to: '', subject: '', message: '' });
//       //    resetEmail();
         
//         })
//         .catch((error) => {
//           setLoading(false);
//          // setEmailErrorList(error.response.data.validate_err);
          
//          console.error('Error sending email:', error.response.data.message);
//         });


//   };

  




    const resetBooking = () => {
        setBooking_date("");
       // setFirstname('');
       // setLastname('');
       // setPhone('');
        //setEmail('');
        setBooking_time([]);
        setKids_count(0);
        setAdults_count(0);
        setTimeSlotDetails((prev) => ({ ...prev, price: 0 }));
        setBirthdayPrice((prev) => ({ ...prev, price: 0 }));
        setNote('');
        setSelectedGameType('');
        setSelectedPackageType('');
        setSelectedBirthdayPackage('');
        setSelectedCorporatePackage('');
        setBirthdayKid('');
        setSelectedFoods('');
        setSelectedDrinks('');
        setSelectedEventFoods('');
        setSelectedEventDrinks('');
        setBirthdayKid('');
        setBookingAvailableTimeSlots([]);
        setGame_count('');
        setGrand_total(0);
        setDeposit_amount(0);
        setExtraGamePrice(0);
        setExtraPlayerPrice(0);
        setBasic_price(0);
        setAmount_paid(0);
        setBookingErrorList([]);
        setPayment_method("");
        setTotalPlayersErrorList('');
        setGameCountErrorList('');
        setEventGameCountErrorList('');

  setInitialSelectionDone(false);
  setCorporateInitialSelectionDone(false);
  setInitialSelectionSlots([]);
  setCorporateInitialSelectionSlots([]);

  

setCustomerById((prev) => ({
  ...prev,
  booking_time: []
}));


    };




    
    const handleFoodOptionChange = (e) => {
        const value = e.target.value;
      //  let updatedLocations = selectedLocations.split(',').map(Number); // Ensure it's an array
        let updatedFoods = [...selectedFoods];
        if (e.target.checked) {
            updatedFoods = [...updatedFoods, value];
        } else {
            updatedFoods = updatedFoods.filter((id) => id !== value);
        }
      
        setSelectedFoods(updatedFoods); // Convert back to a comma-separated string
      };

      const handleDrinkOptionChange = (e) => {
        const value = e.target.value;
      //  let updatedLocations = selectedLocations.split(',').map(Number); // Ensure it's an array
        let updatedDrinks = [...selectedDrinks];
        if (e.target.checked) {
            updatedDrinks = [...updatedDrinks, value];
        } else {
            updatedDrinks = updatedDrinks.filter((id) => id !== value);
        }
      
        setSelectedDrinks(updatedDrinks); // Convert back to a comma-separated string
      };

      const handleEventFoodOptionChange = (e) => {
        const value = e.target.value;
      //  let updatedLocations = selectedLocations.split(',').map(Number); // Ensure it's an array
        let updatedFoods = [...selectedEventFoods];
        if (e.target.checked) {
            updatedFoods = [...updatedFoods, value];
        } else {
            updatedFoods = updatedFoods.filter((id) => id !== value);
        }
      
        setSelectedEventFoods(updatedFoods); // Convert back to a comma-separated string
      };

      const handleEventDrinkOptionChange = (e) => {
        const value = e.target.value;
      //  let updatedLocations = selectedLocations.split(',').map(Number); // Ensure it's an array
        let updatedDrinks = [...selectedEventDrinks];
        if (e.target.checked) {
            updatedDrinks = [...updatedDrinks, value];
        } else {
            updatedDrinks = updatedDrinks.filter((id) => id !== value);
        }
      
        setSelectedEventDrinks(updatedDrinks); // Convert back to a comma-separated string
      };



      const handleAmountPaidChange = (value) => {
        const depositAmount = deposit_amount; // Replace with the actual deposit amount value
        const grandTotal = grand_total; // Replace with the actual grand total value
    
        setAmount_paid(value);
    
        // Validate the amount paid
        if (Number(value) < depositAmount) {
            // setBookingErrorList(prevState => ({
            //     ...prevState,
            //     amount_paid: `Amount paid should not be less than ${depositAmount}.`
            // }));
        } else if (Number(value) > grandTotal) {
            setBookingErrorList(prevState => ({
                ...prevState,
                amount_paid: `Amount paid should not exceed ${grandTotal}.`
            }));
        } else {
            // Clear the error if valid
            setBookingErrorList(prevState => ({
                ...prevState,
                amount_paid: ''
            }));
        }
    };


const applyDiscount = () => {
  const amount = Number(discountValue);

  // Calculate actual discount amount
  const discountAmount = discountType === 'percentage'
    ? ((sub_total + adjustedTotal)* amount) / 100
    : amount;

    
  const newDiscount = {
    type: discountType,
    value: amount,
    description: discountDescription,
    amount: parseFloat(discountAmount.toFixed(2)), 
  };

  // Add to list
  const updatedDiscounts = [...discountDetails, newDiscount];
  setDiscountDetails(updatedDiscounts);

  // Sum all discounts
  const totalDiscount = Math.min(
    updatedDiscounts.reduce((acc, d) => acc + (d.amount || 0), 0),
    sub_total
  );

  setDiscountAmount(parseFloat(totalDiscount.toFixed(2)));

  // Close modal & reset
  setShowDiscountModal(false);
  setDiscountType('');
  setDiscountValue('');
  setDiscountDescription('');
};



     
    const applyPromoCode = () => {
  const selected = promoCodeList.find(code => code.code_name === promoCode);
  if (!selected) return;

  const promoType = Number(selected.is_percentage) ? 'percentage' : 'amount';
  const promoValue = Number(selected.value_amount);

  // Calculate this promo's discount amount
  const amount = promoType === 'percentage'
    ? ((sub_total + adjustedTotal) * promoValue) / 100
    : promoValue;

  const newPromo = {
    code_name: selected.code_name,
    type: promoType,
    value: promoValue,
    amount: amount.toFixed(2), // 👈 store exact discount amount
  };

  const updatedPromos = [...promoDetails, newPromo];

  // Recalculate total promo amount from updatedPromos
  const totalPromoAmount = updatedPromos.reduce((acc, promo) => {
    return acc + (promo.amount ? parseFloat(promo.amount) : 0);
  }, 0);

  const cappedPromoAmount = Math.min(totalPromoAmount, sub_total);

  setPromoDetails(updatedPromos);
  setPromoAmount(parseFloat(cappedPromoAmount.toFixed(2)));
  setShowPromoModal(false);
};



    const handleCloseDiscountModal = () => setShowDiscountModal(false);
    const handleClosePromoModal = () => setShowPromoModal(false);

    

const handleRemoveDiscount = (index) => {
  const removedDiscount = discountDetails[index];
  const removedAmount = removedDiscount?.amount ? parseFloat(removedDiscount.amount) : 0;

  const updatedDiscountDetails = discountDetails.filter((_, i) => i !== index);
  setDiscountDetails(updatedDiscountDetails);

  // Update promo amount
  setDiscountAmount(prev => {
    const newAmount = parseFloat((prev - removedAmount).toFixed(2));
    //console.log("Updated promo amount:", newAmount);
    return newAmount;
  });


};


const handleRemovePromo = (index) => {
  const removedPromo = promoDetails[index];
  const removedAmount = removedPromo?.amount ? parseFloat(removedPromo.amount) : 0;

 // console.log("Removing promo:", removedPromo);
 // console.log("Amount to reduce:", removedAmount);

  // Remove the promo
  const updatedPromoDetails = promoDetails.filter((_, i) => i !== index);
  setPromoDetails(updatedPromoDetails);


    setRemovedPromos(prev => [...prev, removedPromo]);
  // Update promo amount
  setPromoAmount(prev => {
    const newAmount = parseFloat((prev - removedAmount).toFixed(2));
    //console.log("Updated promo amount:", newAmount);
    return newAmount;
  });
};


      

 const handleAddDiscount = () => {
        setDiscountType('');
        setDiscountValue('');
        setDiscountDescription('');
        setShowDiscountModal(true);
      };

      const handleApplyPromo = () => {
        setPromoCode('');
        setShowPromoModal(true);
      };


    return (
        <div>
            <SideNav />
            <TopBar />
            {isLoading ?
                <div className="loader-container" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed", top: "0", left: "0", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", zIndex: "9999" }}>
                    <div class="d-flex justify-content-center">
                        <div class="spinner-border" role="status">
                        </div>
                    </div>
                </div> : null}

            <div className="right_panel position contact_section vh-100" id="right_panel">
                <div className="main_title d-flex align-items-center">
               <h1>
               <i className="bi bi-calendar-check"></i> Edit Booking - {customerById?.booking_ref_id}

</h1>
<button 
    className="btn btn-sm btn_secondary text-white "
      onClick={() => navigate(-1)} // or a custom route like () => navigate('/bookings')
    >  <i className="bi bi-arrow-left fs-6 me-1"></i> Back
    </button>

                </div>

                <div className="content_wrapper pt-0">
                    <div className="vm_content_box_1">
                        {/* <div className="title">
                            <h2>Booking details</h2>
                        </div> */}
                        <div className='row px-4'>


                            <div class="content col-md-2">
                                <div class="form-group pt-3 pb-2">

                                    <select class="form-select" id="selectedGameLocation" name="selectedGameLocation" value={selectedGameLocation} onChange={handleGameAvailableLocationChange} disabled>
                                        <option value="">Select game location</option>
                                        {filteredLocations.map((location) => (
                                            <option key={location.id} value={location.id}>
                                                {location.location_name}
                                            </option>
                                        ))}
                                    </select>   {!selectedGameLocation && (
                                        <span class="text-danger">{error_list.location_id}</span>)}
                                </div>
                            </div>


                            <div class="content col-md-2 ">
                                <div class="form-group pt-3 pb-2">

                                    <select className="form-select me-2" id="game" name="game" value={selectedGame} onChange={handleGameChange} disabled>
                                        <option value="">Select a game</option>
                                        {game_available.map((game) => (
                                            <option key={game.id} value={game.id}>
                                                {game.name}
                                            </option>
                                        ))}
                                    </select> {!selectedGame && (
                                        <span class="text-danger">{error_list.game_id}</span>)}
                                </div>
                            </div>

                        </div>
                        <div className='row'>


                            <div className='col'>
                                {/* <div className="calendar-responsive content pt-3 pb-5 mb-5" id="calender" style={{ boxShadow: "0px 0px 21px 2px rgba(0, 0, 0, 0.18)", backgroundColor: "white", marginTop: "20px", width: '100%', overflowX: 'auto' }}  > */}



<div class="d-flex mt-2 pt-2 px-3 ">


        <div className="vm_content_box_1 mt-2 ">

      
       
        <div class="title">
       
            <h2>Booking Details</h2>

        </div>
        
<div className="content py-0 bg-white px-3 mb-3 w-100" >
            
          

<div className="row">
<div className="col-md-12">
<div className="row border-top pb-3">
                {[
                    // { label: 'Booking Id', value: customerById.booking_ref_id },
                   
                   
                    { label: 'Game Package', 
                        value:  customerById.game_type_name ||
                        (customerById.package_name === 'Corporate' 
                          ? `${customerById.package_name} - ${customerById.corporate_package_name}`
                          : `${customerById.package_name} - ${customerById.game_package_name}`
                        )},
                        // value: customerById.game_type_name ? customerById.game_type_name : `${customerById.package_name} - ${customerById.game_package_name}` },
                    { label: 'Booked Date', value: (
                        <div className="d-flex align-items-center">
                            <i className="bi bi-calendar3 me-2 text-success" ></i>
                            <span>{moment(customerById.booked_date).format('D MMMM YYYY')}</span>
                        </div>
                    ) },
                    { label: 'Booked Time', value: (
                        <div className="d-flex align-items-center">
                            <i className="bi bi-clock-fill me-2 text-success" ></i>
                            <span>{customerById.booked_time_formatted}</span>
                           
                        </div>
                    ) },
                    {
                      label: 'Booked By',
                      value: (
                        <div className="d-flex align-items-center">
                          {
                            customerById.first_name || customerById.last_name
                              ? <span>{customerById.first_name} {customerById.last_name}</span>
                              : <span>Online</span>
                          }
                        </div>
                      )
                    },
                    
                    { label: 'Adult Count', value: customerById.no_of_adults },
                    { label: 'Kids Count', value: customerById.no_of_children },
                   
                   
                    ...(customerById.package_name 
                        ? [
                          
                            { label: 'Birthday Kid Name', value: customerById.birthday_kid_name },
                            ...(customerById.package_name == 'Birthday' 
                                ? 
                                [
                                    {
                                    label: 'Food details',
                                    value: (
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                          <span>
                                            {customerById.food_details && Object.keys(JSON.parse(customerById.food_details || "{}")).length > 0
                                              ? Object.entries(JSON.parse(customerById.food_details)).map(([name, count]) => `${name} (${count})`).join(", ")
                                              : "No food details available"}
                                          </span>
                                         
                                        </div>
                                      )
                              }, 
                        ]
                              
                                : []),
                              
                                ...(customerById.package_name == 'Birthday' 
                                    ? [{
                                        label: 'Drink details',
                                        value: (
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                              <span>
                                              {customerById.drink_details && Object.keys(JSON.parse(customerById.drink_details || "{}")).length > 0
                                               ? Object.entries(JSON.parse(customerById.drink_details || "{}"))
                                                  .map(([name, count]) => `${name} (${count})`)
                                                  .join(", ")
                                                  : "No drink details available"}
                                              </span>
                                              
                                            </div>
                                          )
                                  }]
                                    : []),


                                        ...(customerById.package_name === 'Birthday' || customerById.package_name === 'Corporate' 
                                          ? [
                                              ...(customerById.package_price ? [{ label: 'Package Price', value: customerById.package_price }] : []),
                                              ...(customerById.extra_player_price ? [{ label: 'Extra Player Price', 
                                                  value:  ( <div>{(customerById.extra_player_price)}  {" ("} 
                                                  {customerById.cart_details?.extra_player_price?.total_players} Players X {customerById.cart_details?.extra_player_price?.no_games} Games X ${customerById.cart_details?.extra_player_price?.price_for_slot}
                                                  {")"} </div> ) }] : []),
                                              ...(customerById.extra_game_price ? [{ label: 'Extra Game Price', 
                                                  value: (
                                                      <div>
                                                        {customerById.extra_game_price} {" ("}
                                                        {(() => {
                                                          const aggregated = Object.values(customerById.cart_details || {}).filter(slot => slot.extra_game > 0)
                                                            .reduce((acc, slot) => {
                                                              acc.totalPlayers = slot.total_players; // Assuming the same number of players per row
                                                              acc.totalGames += parseInt(slot.no_games, 10);
                                                              acc.pricePerSlot = parseFloat(slot.price_for_slot);
                                                              return acc;
                                                            }, { totalPlayers: 0, totalGames: 0, pricePerSlot: 0 });
                                              
                                                          const totalPrice = aggregated.totalPlayers * aggregated.pricePerSlot * aggregated.totalGames;
                                              
                                                          return (
                                                            <span>
                                                              {aggregated.totalPlayers} Players  X {aggregated.totalGames} Games X ${aggregated.pricePerSlot.toFixed(2)}
                                                            </span>
                                                          );
                                                        })()}
                                                        {")"}
                                                      </div>
                                                    ) }] : []),
                                            ]
                                          : []),
                                      // { label: 'Hst', value: customerById.hst && customerById.hst },
                                                

                        ]
                        : []),

                        { label: 'Sub Total', value: customerById.subtotal ? customerById.subtotal.toFixed(2) : '0.00'},
                        { label: 'Total Amount (After hst)', value: customerById.grand_total ? customerById.grand_total.toFixed(2) : '0.00'},
                        {
                            label: 'Amount Paid',
                            value: paymentHistory.reduce((total, payment) => total + parseFloat(payment.payment_amount), 0).toFixed(2)
                        },
                 

           

                ].map((detail, index) => (
                    <div className="d-flex border-bottom py-2" key={index}>
                        <div className="col-5 p-1 border-end vm_font_bold text-secondary">{detail.label}</div>
                        <div className="col-7 p-1 ps-3">{detail.value}</div>
                    </div>
                ))}
            </div>


          
</div>


</div>

</div>

            
        </div>
    </div>

                               

                                {/* </div> */}
                            </div>

                            {view === 'form' && (
                                // booking_date && (
                                    <div className='col-md-4'>

                                        <div class="py-3 mt-4 border bg-white">
                                            <h3 class="vm_font_semi_bold border-bottom mb-3 px-3 pb-2">
                                               Edit Booking Form
                                            </h3>



                                            <div className="container">
    <div className="col">
        {/* Box 1 */}
        <div className="col-md-12">
            <div className="form-box py-4 px-3 bg-light border  shadow-sm mb-4">
                {/* <h5 className="box-title mb-4">Personal Information</h5> */}
                
                <div className="col-md-12">



              
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group ">
                                                                    <label htmlFor="date"> Date</label>
                                                                    <div class="d-flex input_wrapper">
                                                                        <div class="icon_wrapper">
                                                                            <i class="bi bi-calendar2-plus icon"></i>
                                                                        </div>

                                                                        <input type="date" id="booking_date" min={new Date().toLocaleDateString('en-CA')} 
                                                                         value={booking_date} className="form-control" onChange={(e) => handleBookingDateChange(e.target.value)}  />


                                                                    </div>
                                                                    <span class="text-danger">{bookingErrorList.booked_date}</span>
                                                                </div>
                                                            </div>


                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label htmlFor="selectedPackageType">Select Package Type</label>
                                                                    <select
                                                                        className="form-select"
                                                                        id="selectedPackageType"
                                                                        name="selectedPackageType"
                                                                        value={selectedPackageType}
                                                                        onChange={(e) => {setSelectedPackageType(e.target.value); setSelectedGameType('');setSelectedBirthdayPackage('');setSelectedCorporatePackage('');
                                                                            if(selectedPackageType === 'birthday_package')
                                                                            {fetchGamePackages(1)}
                                                                            else if(selectedPackageType == 'corporate_event')
                                                                            {fetchCorporateEvents(2)}
                                                                        }}
                                                                        
                                                                    >
                                                                        <option value="">Select Package Type</option>
                                                                        <option value="laser_tag_package">Laser Tag package</option>
                                                                        <option value="birthday_package">Birthday Package</option>
                                                                        <option value="corporate_event">Corporate Event</option>
                                                                    </select>
                                                                    <span className="text-danger">{bookingErrorList.selectedPackageType}</span>
                                                                </div>
                                                            </div>




                                                            {selectedPackageType === 'laser_tag_package' && (
                                                                <div class="col-md-6">
                                                                    <div class="form-group">
                                                                        <label htmlFor="game_type"> Select Game Type</label>
                                                                        <select class="form-select" id="game_type" name="game_type" value={selectedGameType} onChange={handleGameTypeChange}>
                                                                            <option value="">Select game type</option>
                                                                            {game_types.map((game_type) => (
                                                                                <option key={game_type.id} value={game_type.id}>
                                                                                    {game_type.game_type_name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                        <span class="text-danger">{bookingErrorList.game_type_id}</span>
                                                                    </div>
                                                                </div>
                                                            )}


                                                            {selectedPackageType === 'birthday_package' &&  (
                                                                 <div className='col-md-12'>
                                                                   <div className='row'>
                                                                    <div class="col-md-6">
                                                                    <div class="form-group">
                                                                        <label htmlFor="birthday_package"> Select Birthday Package</label>
                                                                        <select class="form-select" id="birthday_package" name="birthday_package" value={selectedBirthdayPackage} onChange={handleBirthdayPackageChange}>
                                                                            <option value="">Select Birthday package</option>
                                                                            {game_packages.map((game_package) => (
                                                                                <option key={game_package.id} value={game_package.id}>
                                                                                    {game_package.sub_package_name}
                                                                                </option>
                                                                            ))}

                                                                        </select>
                                                                        
                                                                        <span class="text-danger">{bookingErrorList.game_package_id}</span>
                                                                    </div>
                                                                </div>
                                                                { selectedBirthdayPackage &&  
                                                                <div className="col-md-6">
            <div className="form-group">
                <label htmlFor="birthday_kid">Birthday Kid Name</label>
            
                <input type="text" id="birthday_kid" className="form-control" value={birthdayKid} onChange={(e) => setBirthdayKid(e.target.value)} placeholder='Enter birthday Kid name'/>
                <span className="text-danger">{bookingErrorList.birthday_kid}</span>
               
            </div>
        </div>
}
      

     {/* { selectedBirthdayPackage && (birthday_packages.sub_package_name !== 'Bronze') && ( */}
     {selectedBirthdayPackage && (birthday_packages.food_quantity > 0) && (
  <div className="col-md-6">
    <div className="form-group">
      <label htmlFor="food_details" >Food Details</label>
      {birthday_packages.food_quantity && (
        <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
          *Select {birthday_packages.food_quantity} food options.
        </div>
      )}
      <div className="px-2 py-2 bg-white mt-1 ">
        {foodOptions.map((food, index) => (
          <div
            className="d-flex align-items-center justify-content-between py-1"
            key={index}
           
          >
            <label style={{ marginTop: '5px' }}>{food}</label>
            <div className="d-flex align-items-center">
              <button
                type="button"
                className="btn btn-outline-secondary"
                style={{
                  width: '25px',
                  height: '25px',
                  padding: '0',
                  fontSize: '1.0em',
                   fontWeight: 'bold'
                }}
                onClick={() => handleDecrement(food)}
                disabled={selectedFoods[food] <= 0}
              >
                -
              </button>
              <span className="mx-2" >{selectedFoods[food] || 0}</span>
              <button
                type="button"
                className="btn btn-outline-secondary"
                style={{
                  width: '25px',
                  height: '25px',
                  padding: '0',
                  fontSize: '1.0em',
                  fontWeight: 'bold'
                }}
                onClick={() => handleIncrement(food)}
                disabled={getTotalSelectedFoods() >= birthday_packages.food_quantity}
              >
                +
              </button>
            </div>
          </div>
        ))}
          {/* <span class="text-danger">{foodErrorList}</span> */}
        <span className="text-danger" >{bookingErrorList.food_details}</span>
      </div>
    </div>
  </div>
)}
    {selectedBirthdayPackage && (birthday_packages.drink_quantity > 0) && (
  <div className="col-md-6">
    <div className="form-group">
      <label htmlFor="food_details" >Drink Details</label>
      {birthday_packages.drink_quantity && (
        <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
          *Select {birthday_packages.drink_quantity} drink options.
        </div>
      )}
      <div className="px-2 py-2 bg-white mt-1 ">
        {drinkOptions.map((drink, index) => (
          <div
            className="d-flex align-items-center justify-content-between py-1"
            key={index}
           
          >
            <label style={{ marginTop: '5px' }}>{drink}</label>
            <div className="d-flex align-items-center">
              <button
                type="button"
                className="btn btn-outline-secondary"
                style={{
                  width: '25px',
                  height: '25px',
                  padding: '0',
                  fontSize: '1.0em',
                   fontWeight: 'bold'
                }}
                onClick={() => handleDrinkDecrement(drink)}
                disabled={selectedDrinks[drink] <= 0}
              >
                -
              </button>
    
              <span className="mx-2" >{selectedDrinks[drink] || 0}</span>
              <button
                type="button"
                className="btn btn-outline-secondary"
                style={{
                  width: '25px',
                  height: '25px',
                  padding: '0',
                  fontSize: '1.0em',
                  fontWeight: 'bold'
                }}
                onClick={() => handleDrinkIncrement(drink)}
                disabled={getTotalSelectedDrinks() >= birthday_packages.drink_quantity}
              >
                +
              </button>
            </div>
          </div>
        ))}
             {/* <span class="text-danger">{foodErrorList}</span> */}
        <span className="text-danger" >{bookingErrorList.drink_details}</span>
      </div>
    </div>
  </div>
)}

 </div>   
</div>


         )}




{selectedPackageType === 'corporate_event' &&  (
   <><div class="col-md-6">
                                                                    <div class="form-group">
                                                                        <label htmlFor="corporate_event"> Select Corporate Package</label>
                                                                        <select class="form-select" id="corporate_event" name="corporate_event" value={selectedCorporatePackage} onChange={handleCorporatePackageChange}>
                                                                            <option value="">Select Corporate package</option>
                                                                            {corporate_events.map((corporate_event) => (
                                                                                <option key={corporate_event.id} value={corporate_event.id}>
                                                                                    {corporate_event.sub_package_name}
                                                                                </option>
                                                                            ))}

                                                                        </select>
                                                                        
                                                                        <span class="text-danger">{bookingErrorList.corporate_event_id}</span>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-12'>
                                                                <div className='row'>
                                                    
      
      
    
         { selectedCorporatePackage && (corporate_packages.food_quantity > 0) && (
        <>  <div className="col-md-6">
        <div className="form-group">
          <label htmlFor="food_details" >Food Details</label>
          {corporate_packages.food_quantity && (
            <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
              *Select {corporate_packages.food_quantity} food options.
            </div>
          )}
          <div className="px-2 py-2 bg-white mt-1 ">
            {eventFoodOptions.map((food, index) => (
              <div
                className="d-flex align-items-center justify-content-between py-1"
                key={index}
               
              >
                <label style={{ marginTop: '5px' }}>{food}</label>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    style={{
                      width: '25px',
                      height: '25px',
                      padding: '0',
                      fontSize: '1.0em',
                       fontWeight: 'bold'
                    }}
                    onClick={() => handleEventFoodDecrement(food)}
                    disabled={selectedEventFoods[food] <= 0}
                  >
                    -
                  </button>
                
                  <span className="mx-2" >{selectedEventFoods[food] || 0}</span>
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    style={{
                      width: '25px',
                      height: '25px',
                      padding: '0',
                      fontSize: '1.0em',
                      fontWeight: 'bold'
                    }}
                    onClick={() => handleEventFoodIncrement(food)}
                    disabled={getTotalSelectedEventFoods() >= corporate_packages.food_quantity}
                  >
                    +
                  </button>
                </div>
              </div>
            ))}
            <span className="text-danger" >{bookingErrorList.selectedEventFoods}</span>
          </div>
        </div>
      </div>
    </>)}

  {selectedCorporatePackage && (corporate_packages.drink_quantity > 0) && (
     <div className="col-md-6">
     <div className="form-group">
       <label htmlFor="food_details" >Drink Details</label>
       {corporate_packages.drink_quantity && (
         <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
           *Select {corporate_packages.drink_quantity} drink options.
         </div>
       )}
       <div className="px-2 py-2 bg-white mt-1 ">
         {eventDrinkOptions.map((drink, index) => (
           <div
             className="d-flex align-items-center justify-content-between py-1"
             key={index}
            
           >
             <label style={{ marginTop: '5px' }}>{drink}</label>
             <div className="d-flex align-items-center">
               <button
                 type="button"
                 className="btn btn-outline-secondary"
                 style={{
                   width: '25px',
                   height: '25px',
                   padding: '0',
                   fontSize: '1.0em',
                    fontWeight: 'bold'
                 }}
                 onClick={() => handleEventDrinkDecrement(drink)}
                 disabled={selectedEventDrinks[drink] <= 0}
               >
                 -
               </button>
               <span className="mx-2" >{selectedEventDrinks[drink] || 0}</span>
               <button
                 type="button"
                 className="btn btn-outline-secondary"
                 style={{
                   width: '25px',
                   height: '25px',
                   padding: '0',
                   fontSize: '1.0em',
                   fontWeight: 'bold'
                 }}
                 onClick={() => handleEventDrinkIncrement(drink)}
                 disabled={getTotalSelectedEventDrinks() >= corporate_packages.drink_quantity}
               >
                 +
               </button>
             </div>
           </div>
         ))}
         <span className="text-danger" >{bookingErrorList.selectedEventDrinks}</span>
       </div>
     </div>
   </div>
)}
       
        </div> 
        </div></>


                                                            )}



                                                        </div>


                                                    </div>



            </div>
        </div>

        {/* Box 2 */}
        <div className="col-md-12">
            <div className="form-box py-4 px-3 bg-light border shadow-sm">
                {/* <h5 className="box-title mb-4">Contact Details</h5> */}
                <div className="row">
                <div className="col-md-6">
             
                                                        <div className="form-group">
                                                            <label htmlFor="firstname">First Name</label>
                                                            <input type="text" className="form-control" id="firstname" value={firstname} onChange={(e) => setFirstname(e.target.value)} placeholder="Enter First Name" readOnly />
                                                            <span class="text-danger">{bookingErrorList.firstname}</span>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="lastname">Last Name</label>
                                                            <input type="text" className="form-control" id="lastname" value={lastname} onChange={(e) => setLastname(e.target.value)} placeholder="Enter Last Name" readOnly />
                                                            <span class="text-danger">{bookingErrorList.lastname}</span>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 form-group">
                                                        <label for="phone">Phone Number</label>
                                                        <input type="text" class="form-control" name="phone" id="phone" placeholder="Enter Phone Number" value={phone} readOnly
                                                            onChange={(event) => { setPhone(event.target.value); }} />
                                                        <span class="text-danger">{bookingErrorList.phone}</span>
                                                    </div>
                                                    <div class="col-md-6 form-group">
                                                        <label for="email">Email</label>
                                                        <input type="text" class="form-control" name="email" id="email" value={email} placeholder="Enter Email Address" readOnly
                                                            onChange={(event) => { setEmail(event.target.value); }} />

                                                        <span class="text-danger">{bookingErrorList.email}</span>
                                                  
                                                    </div>

                                                    {selectedGameType && (
            <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
                *The total no of players must be between {minPlayers} and {maxPlayers}.
            </div>
        )}
          {selectedBirthdayPackage  && (
            <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
                *The total no of players must be between {birthday_packages.min_players} and {birthday_packages.max_players_in_a_slot }.
            </div>
        )}
          {selectedCorporatePackage  && (
            <div className="mb-1 text-muted" style={{ fontSize: '0.9em', marginTop: '-5px' }}>
                *The total no of players must be between {corporate_packages.min_players} and {corporate_packages.max_players_in_a_slot }.
            </div>
        )}


                                                    <div className="col-md-4">
                                                        <div className="form-group py-2">
                                                            <label htmlFor="kids_count">Kids</label>
                                                            <input
                                                                type="number"
                                                                id="kids_count"
                                                                name="kids_count"
                                                                value={kids_count}
                                                                className="form-control"
                                                               // onChange={(e) => { setKids_count(e.target.value); }}
                                                                onChange={(e) => {
                                                                    if(!selectedPackageType)
                                                                    {
                                                                        alert('Please select Package Type.');
                                                                        setKids_count(0);
                                                                    }
                                                                else if (selectedPackageType == 'laser_tag_package'  && !selectedGameType) {
                                                                    alert('Please select a Game Type.');
                                                                    // Reset the input to 0 to prevent further changes until birthday package is selected
                                                                    setKids_count(0);
                                                                } else if (selectedPackageType == 'birthday_package'  && !selectedBirthdayPackage){
                                                                    alert('Please select a birthday package.');
                                                                    // Reset the input to 0 to prevent further changes until birthday package is selected
                                                                    setKids_count(0);
                                                                }
                                                                else if (selectedPackageType == 'corporate_event'  && !selectedCorporatePackage){
                                                                    alert('Please select a corporate package.');
                                                                    // Reset the input to 0 to prevent further changes until birthday package is selected
                                                                    setKids_count(0);
                                                                }
                                                                else{
                                                                    setKids_count(e.target.value);
                                                                }
                                                            }}
                                                                min="0"
                                                                required
                                                            />
                                                        </div>
                                                    </div>   <div className="col-md-4">
                                                        <div className="form-group py-2">
                                                            <label htmlFor="kids_count">Adults</label>
                                                            <input
                                                                type="number"
                                                                id="adults_count"
                                                                name="adults_count"
                                                                value={adults_count}
                                                                className="form-control"
                                                                // onChange={(e) => { setAdults_count(e.target.value); }}
                                                                onChange={(e) => {
                                                                    if(!selectedPackageType)
                                                                    {
                                                                        alert('Please select Package Type.');
                                                                        setAdults_count(0);
                                                                    }
                                                                else if (selectedPackageType == 'laser_tag_package'  && !selectedGameType) {
                                                                    alert('Please select a Game Type.');
                                                                    // Reset the input to 0 to prevent further changes until birthday package is selected
                                                                    setAdults_count(0);
                                                                } else if (selectedPackageType == 'birthday_package'  && !selectedBirthdayPackage){
                                                                    alert('Please select a birthday package.');
                                                                    // Reset the input to 0 to prevent further changes until birthday package is selected
                                                                    setAdults_count(0);
                                                                }
                                                                else if (selectedPackageType == 'corporate_event'  && !selectedCorporatePackage){
                                                                    alert('Please select a corporate package.');
                                                                    // Reset the input to 0 to prevent further changes until birthday package is selected
                                                                    setAdults_count(0);
                                                                }
                                                                else{
                                                                    setAdults_count(e.target.value);
                                                                }
                                                            }}
                                                                required
                                                                min="0"
                                                            />
                                                        </div>
                                                    </div>


                                                 
                                                    <span class="text-danger">{totalPlayersErrorList}</span>
                                                    {/* <span class="text-danger">{bookingErrorList.total_players}</span> */}
                                                 
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="booking_time">Select Time:</label>
                                                            <div id="booking_time" className="form-control py-3">
                                                           
                                                                        
                                                                {timeSlotLoading ? (
                                                                    <div>Loading...</div>
                                                                ) : (


                                                                    bookingAvailableTimeSlots
                                                                    .map((timeSlot, index) => {
                                                                        const remainingSpace = availableSpaces[timeSlot] || 0;
                                                                         const game_type = game_types_array.find(item => item.id.toString() === selectedGameType);
                                                                          const isBooked = customerById?.booking_time.includes(timeSlot);
                                                                         let isDisabled = Array.isArray(disabledTimeSlots) && disabledTimeSlots.includes(timeSlot)&& !isBooked;
                                                                
                                                                       // Handle specific logic for "Private" game type
                                                                        if (game_type && game_type.game_type_name.toLowerCase().includes('private')) {
                                                                            // Disable slots that do not have exactly max players available
                                                                            if (remainingSpace !== game_type.max_players_in_a_slot 
                                                                                 && !isBooked 
                                                                            ) {
                                                                                isDisabled = true;
                                                                            }
                                                                        }
                                                                       

                                                                        // Handle specific logic for "Birthday Package"
                                                                            if (selectedPackageType === 'birthday_package' && game_packages.length > 0) {
                                                                                const maxPlayers = game_packages[0].max_players_in_a_slot; // Get max players allowed in a slot
                                                                            
                                                                                // Check if the current slot has enough availability for the package requirement
                                                                                const currentSlot = bookingAvailableTimeSlots[index]; // Current slot being processed
                                                                                const remainingSpace = availableSpaces[currentSlot] || 0;
                                                                            
                                                                                // Disable the slot if it doesn't have the required player availability
                                                                                if (remainingSpace !== maxPlayers && !isBooked 
                                                                                ) {
                                                                                    isDisabled = true;
                                                                                }
                                                                                
                                                                            }

                                                                        if (selectedPackageType === 'corporate_event' && corporate_events.length > 0) {
                                                                            const maxPlayers = corporate_events[0].max_players_in_a_slot; // Get max players allowed in a slot
                                                                        
                                                                            // Check if the current slot has enough availability for the package requirement
                                                                            const currentSlot = bookingAvailableTimeSlots[index]; // Current slot being processed
                                                                            const remainingSpace = availableSpaces[currentSlot] || 0;
                                                                        
                                                                            // Disable the slot if it doesn't have the required player availability
                                                                            if (remainingSpace !== maxPlayers  && !isBooked
                                                                            ) {
                                                                                isDisabled = true;
                                                                            }
                                                                        }
                                                                        
                                                                       
                                                                        // const currentTime = dayjs(); // Get current system time
                                                                        // const slotStartTimeString = timeSlot.split(" - ")[0]; // Extract "04:30 PM" from "04:30 PM - 05:00 PM"
                                                                        // const slotStartTime = dayjs(slotStartTimeString, "hh:mm A", true); // Parse correctly
                                                                        
                                                                        // if (!slotStartTime.isValid()) {
                                                                        //   console.error("Invalid time format:", slotStartTimeString);
                                                                        // }
                                                                        
                                                                        // // Disable slots that have already passed for today
                                                                        // if (dayjs(selectedDate).isSame(dayjs(), "day") && slotStartTime.isValid() && slotStartTime.isBefore(currentTime) && !isBooked) {
                                                                        //   isDisabled = true;
                                                                        // }
                                                                       

                                                                        if (booking_time.includes(timeSlot) ) {
                                                                            isDisabled = false;
                                                                        }

                                                                      
                                                                        return (
                                                                            <div
                                                                                key={index}
                                                                                className="form-group-checkbox d-flex align-items-center justify-content-between"
                                                                                style={isDisabled ? { color: '#a9a9a9', opacity: 0.6, pointerEvents: 'none' } : {}}
                                                                            >
                                                                                <div className="d-flex align-items-center">
                                                                                    <div>
                                                                                        <input
                                                                                            style={{ boxShadow: "2px 2px #059618", transition: "all .5s ease" }}
                                                                                            type="checkbox"
                                                                                            className="checkbox"
                                                                                            id={`timeslot_${index}`}
                                                                                            value={ timeSlot}
                                                                                            //value={booking_time} 
                                                                                            checked={booking_time.includes(timeSlot)}
                                                                                            onChange={handleTimeSlotChange}
                                                                                            disabled={isDisabled}
                                                                                        />
                                                                                        <label
                                                                                            htmlFor={`timeslot_${index}`}
                                                                                            style={{ marginLeft: "5px" }}
                                                                                        >
                                                                                            <span style={isDisabled ? { textDecoration: 'line-through' } : {}}>
                                                                                                {timeSlot}
                                                                                            </span>
                                                                                            <span style={{ color: 'green', marginLeft: '30px' }}>
                                                                                                {remainingSpace} left
                                                                                            </span>
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })
                                                                
                                                                )}
                                                               
                                                            </div>
                                                            <span className="text-danger">{bookingErrorList.booked_time}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 pb-3">
    <div className="card shadow-sm p-3" >
        {/* Cart Header with Icon */}
        <div className="cart-header text-center pb-2">
        <h5 className="d-flex align-items-center justify-content-center fw-bold">
            <i className="bi bi-bag-fill text-success me-2" style={{ fontSize: "1.2rem", fontWeight:'bold' }}></i> 
            <span style={{ fontSize: "1.3rem" }}>CART</span>
        </h5>
    </div>

        {/* Time Slot Details */}
        <ul className="list-group list-group-flush" style={{lineHeight:'unset'}}>
        {Object.keys(cart_details).map((key, index) => {
        const slot = cart_details[key];

        return (
            <li key={index} className="list-group-item d-flex flex-column p-3">
                <div className="d-flex justify-content-between" style={{ fontSize: "0.85rem" }}>
                    {selectedPackageType === "laser_tag_package" ? (
                        <span>
                            {slot.time_slot} - {slot.total_players} X ${slot.price_for_slot}
                        </span>
                    ) : (
                      
                            slot.no_games > 1 ? (
                               
                               slot.price_for_slot == 0 ? (
                                <span>
                                    {slot.time_slot} - 1 X ${slot.row_total}
                                </span>
                            ) : (
                                <span>
                                {slot.time_slot} <br />
                                {slot.total_players} Players X {slot.no_games} Games X ${slot.price_for_slot}
                            </span>
                            )

                              
                            ) : (
                                <span>
                                    {slot.time_slot} <br />
                                    {slot.total_players} Players X ${slot.price_for_slot}
                                </span>
                            )
                        
                    )}
                    <strong >${slot.row_total}</strong>
                </div>
            </li>
        );
    })}

    {/* Display Extra Games and Players Separately */}
    {cart_details["extra_games"] &&
        cart_details["extra_games"].map((extraGame, index) => (
            <li key={`extra_game_${index}`} className="list-group-item d-flex flex-column p-3">
                <div className="d-flex justify-content-between" style={{ fontSize: "0.85rem" }}>
                    <span>
                        {extraGame.time_slot} <br />
                        {extraGame.total_players} Players X ${extraGame.price_for_slot}
                    </span>
                    <strong className="text-success">${extraGame.row_total}</strong>
                </div>
            </li>
        ))}

            {/* Base Package Price */}
            {basic_price > 0 && (
                <li className="list-group-item d-flex justify-content-between">
                  <span className="fw-bold text-success" style={{ fontSize: "1.0rem" }}>Base Package Price</span>
                    <strong className="fw-bold text-success"  style={{ fontSize: "1.0rem" }}>${basic_price.toFixed(2)}</strong>
                </li>
            )}

            {/* Extra Charges */}
            {extraPlayerPrice > 0 && (
                <li className="list-group-item d-flex justify-content-between">
                    <span className="fw-bold">Extra Player Price</span>
                    <strong className="fw-bold">${extraPlayerPrice.toFixed(2)}</strong>
                </li>
            )}
            {extraGamePrice > 0 && (
                <li className="list-group-item d-flex justify-content-between">
                    <span className="fw-bold">Extra Game Price</span>
                    <strong className="fw-bold">${extraGamePrice.toFixed(2)}</strong>
                </li>
            )}







            {/* Subtotal */}
            <li className="list-group-item d-flex justify-content-between border-top">
    <span className="text-success fw-bold">SUB TOTAL</span>
    <strong className="text-success fw-bold">

    ${sub_total.toFixed(2)}
       
    {/* ${(
        selectedCorporatePackage && corporatePrice?.price
            ? Number(corporatePrice.price)
            : selectedBirthdayPackage && birthdayPrice?.price
            ? Number(birthdayPrice.price)
            : timeSlotDetails?.price
            ? Number(timeSlotDetails.price)
            : Number(customerById?.subtotal || 0)
    ).toFixed(2)} */}
</strong>

</li>


{adjustmentHistory && adjustmentHistory
  .map((item, index) => {
    const amount = parseFloat(item.adjusted_amount);
    const formattedAmount = amount < 0
      ? `-$${Math.abs(amount).toFixed(2)}`
      : `$${amount.toFixed(2)}`;
      

  return (
    <li key={index} className="list-group-item d-flex justify-content-between" style={{ minWidth: '120px' }}>
      <span className="fw-bold">{item.adjusted_reason || 'Adjustments'}</span>
      <span className="fw-bold">
         {formattedAmount}
      </span>
    </li>
  );
})}

{discountDetails.map((discount, index) => {
  const label =
    discount.type === 'percentage'
      ? `${discount.description || 'Discount'} (${discount.value}%)`
      : discount.description || 'Discount';

  const displayAmount = `$${Number(discount.amount).toFixed(2)}`;

  return (
    <li key={index} className="list-group-item d-flex justify-content-between" style={{ minWidth: '120px' }}>
      <span className="fw-bold">{label}</span>
      <span className="fw-bold">
        - {displayAmount}
        <i
          className="bi bi-trash3 ms-2 text-danger"
          style={{ fontSize: '0.75rem', cursor: 'pointer' }}
          onClick={() => handleRemoveDiscount(index)}
          title="Remove discount"
        ></i>
      </span>
    </li>
  );
})}





 {promoDetails.map((promo, index) => {
  // Label shows code and percentage if applicable
  const label =
    promo.type === "percentage"
      ? `${promo.code_name} (${promo.value}%)`
      : promo.code_name;

  // Display promo amount directly (e.g., "$20.00" or "20%")
  const displayAmount =`$${Number(promo.amount).toFixed(2)}`;

  return (
    <li key={index} className="list-group-item d-flex justify-content-between" style={{ minWidth: '120px' }}>
      <span className="fw-bold">{label}</span>
      <span className="fw-bold">
        - {displayAmount}
        <i
          className="bi bi-trash3 ms-2 text-danger"
          style={{ fontSize: '0.75rem', cursor: 'pointer' }}
          onClick={() => handleRemovePromo(index)}
          title="Remove promo code"
        ></i>
      </span>
    </li>
  );
})}



<li className="list-group-item d-flex justify-content-between">
                <span className="fw-bold">TOTAL (before HST)</span>
               <strong className="fw-bold">${totalBeforeHst.toFixed(2)}</strong>
            </li>

            {/* HST */}
            <li className="list-group-item d-flex justify-content-between">
                <span className="fw-bold">HST</span>
                <strong className="fw-bold">${hst.toFixed(2)}</strong>
            </li>

            {/* Grand Total */}
            <li className="list-group-item d-flex justify-content-between fw-bold">
                <span>GRAND TOTAL</span>
                <strong>${grand_total.toFixed(2)}</strong>
            </li>

           
            {/* <li className="list-group-item d-flex flex-column">
            <span className="fw-bold">Deposit</span>
            <span className="text-muted">{depositInfo}</span>
            </li>

        
            <li>
                <input
                    type="text"
                    className="form-control text-center "
                    value={Number(deposit_amount).toFixed(2)}
                    readOnly
                />
            </li> */}
        </ul>

        {/* Error Message */}
        {bookingErrorList.deposit_amount && (
            <span className="text-danger">{bookingErrorList.deposit_amount}</span>
        )}
    </div>
</div>


     <li className="list-group-item d-flex justify-content-between p-3">
<button className="btn btn-sm btn-primary" onClick={handleAddDiscount}><i className={`bi bi-plus-circle `}></i> Discount</button>
<button className="btn btn-primary btn-sm" onClick={handleApplyPromo}>
<i className={`bi bi-plus-circle `}></i> Promo Code
    </button>
</li>                                         

                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="note">Note</label>
                                                            <input type="text" className="form-control" id="note" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Enter Note" />
                                                            <span class="text-danger">{bookingErrorList.note}</span>
                                                        </div>
                                                    </div>


                                                    <div className="col-md-8 form-group">
        <div className="form-group-checkbox d-flex align-items-center justify-content-between">
            <div  className="d-flex align-items-center">
                <input
                    type="checkbox"
                    id="sendNotificationCheckbox"
                    defaultChecked={true}
                    style={{
                        height:'15px', width:'15px',
                        border:' solid' ,
                        boxShadow: "2px 2px #059618", transition: "all .5s ease"// Optional: Add cursor pointer for better UX
                    }}
                    required
                />
                <label  htmlFor="consent" style={{ marginTop: '10px' }}>
                Send email notification
                </label>
            </div>
            <span className="text-danger">{error_list.consent}</span>
            </div>
        </div>








</div>


               
            </div>
        </div>
    </div>
</div>





                                            <div className="content px-3">
                                               
                                                   

                                    




                                                    <div class="d-flex justify-content-end ms-auto py-3">


                                                        <button onClick={updateBooking} class="btn btn-sm btn_secondary text-white "><i class="bi bi-send"></i>  {loading ? "Updating..." : "Update"} </button>
                                                    </div>   
                                            </div>

                                        </div>
                                    </div>
                                // )
                            )}



{view === 'details' && (
    <div className='col-md-4'>
        <div className="py-3 mt-4 border-top bg-light rounded shadow-sm">
            <h3 className="vm_font_semi_bold border-bottom mb-3 px-3 pb-2 ">
                Booking Details
            </h3>
<div className="content py-0 bg-white px-3 py-3 shadow-lg mb-3 w-100" >
            <div className="text-center">
                <h2 className="vm_font_bold mt-2">{bookingDetails.firstname} {bookingDetails.lastname}</h2>
                <div className="d-flex justify-content-center mb-3">
                    <a style={{ cursor: "pointer" }} className="d-flex align-items-center pe-3 text-decoration-none text-dark">
                        <i className="bi bi-telephone-fill me-2 text-success"></i>
                        <p className="mb-0">{bookingDetails.phone}</p>
                    </a>

                    <a style={{ cursor: "pointer" }} className="d-flex align-items-center text-decoration-none text-dark">
                        <i className="bi bi-envelope-fill me-2 text-success"></i>
                        <p className="mb-0">{bookingDetails.email}</p>
                    </a>
                </div>
            </div>

            <div className="row border-top pb-3">
                {[
                    { label: 'Game Name', value: bookingDetails.game_name },
                    { label: 'Location', value: bookingDetails.location_name },
                    { label: 'Game Package', value:  bookingDetails.game_type_name ||
                        (bookingDetails.package_name === 'Corporate' 
                          ? `${bookingDetails.package_name} - ${bookingDetails.corporate_package_name}`
                          : `${bookingDetails.package_name} - ${bookingDetails.game_package_name}`
                        )},
                        // value: bookingDetails.game_type_name ? bookingDetails.game_type_name : `${bookingDetails.package_name} - ${bookingDetails.game_package_name}` },
                    { label: 'Booked Date', value: (
                        <div className="d-flex align-items-center">
                            <i className="bi bi-calendar3 me-2 text-success" ></i>
                            <span>{moment(bookingDetails.booked_date).format('D MMMM YYYY')}</span>
                        </div>
                    ) },
                    { label: 'Booked Time', value: (
                        <div className="d-flex align-items-center">
                            <i className="bi bi-clock-fill me-2 text-success" ></i>
                            <span>{bookingDetails.booked_times}</span>
                        </div>
                    ) },
                    { label: 'Adult Count', value: bookingDetails.no_of_adults },
                    { label: 'Kids Count', value: bookingDetails.no_of_children },
                    { label: 'Amount paid', value: bookingDetails.amount_paid },
                    
                    ...(bookingDetails.package_name 
                        ? [
                          
                            { label: 'Birthday Kid Name', value: bookingDetails.birthday_kid_name },
                            ...(bookingDetails.food_details
                                ? [{
                                    label: 'Food details',
                                    value: Object.entries(JSON.parse(bookingDetails.food_details || "{}"))
                                      .map(([name, count]) => `${name} (${count})`)  // Format as "Cheese (1)"
                                      .join(", ")  // Join with ", " for proper display
                                }]
                                : []),
                            
                            ...(bookingDetails.drink_details
                                ? [{
                                    label: 'Drink details',
                                    value: Object.entries(JSON.parse(bookingDetails.drink_details || "{}"))
                                      .map(([name, count]) => `${name} (${count})`)  // Format as "Cheese (1)"
                                      .join(", ")  // Join with ", " for proper display
                                }]
                                : []),
                           

                        ]
                        : [])

                    
                
                ].map((detail, index) => (
                    <div className="d-flex border-bottom py-2" key={index}>
                        <div className="col-5 p-1 border-end vm_font_bold text-secondary">{detail.label}</div>
                        <div className="col-7 p-1 ps-3">{detail.value}</div>
                    </div>
                ))}
          
   <div class="d-flex justify-content-center pt-3 ">
<button class="btn btn-sm btn_secondary"  onClick={() => handleViewBookings(bookingDetails.booking_id)}  >
View More Details</button>
</div>

            </div>
        </div>
    </div>
    </div>
)}

 </div>


                    </div>
                </div>
            </div>







  <Modal show={showDiscountModal} onHide={handleCloseDiscountModal}>
  <Modal.Header closeButton>
    <Modal.Title>Apply Discount</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div className="mb-3">
    <div className="form-group">
      <label htmlFor="discountType">Discount Type</label>
      <select
        className="form-control"
        value={discountType}
        onChange={e => setDiscountType(e.target.value)}
      >
        <option value="">Select Type</option>
        <option value="percentage">Percentage</option>
        <option value="amount">Fixed Amount</option>
      </select>
    </div>
    </div>

    <div className="mb-3">
    <div className="form-group">
    <label htmlFor="discountValue">Discount Value</label>
      <input
        type="number"
        className="form-control"
        value={discountValue}
        onChange={e => setDiscountValue(e.target.value)}
     
      />
    </div>
    </div>

    <div className="mb-3">
    <div className="form-group">
    <label htmlFor="description">Description</label>
      <textarea
        className="form-control"
        rows={3}
        value={discountDescription}
        onChange={e => setDiscountDescription(e.target.value)}
       
      />
    </div>
    </div>
  </Modal.Body>

  <Modal.Footer>
 
  <button class="btn btn-sm btn_secondary" onClick={applyDiscount}>
      Apply
    </button>
  </Modal.Footer>
</Modal>


<Modal show={showPromoModal} onHide={handleClosePromoModal}>
  <Modal.Header closeButton>
    <Modal.Title>Apply Promo Code</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div className="mb-3">
    <div className="form-group">
      <label htmlFor="promoCode">Promo Code</label>
      <select
        className="form-control"
        value={promoCode}
        onChange={e => setPromoCode(e.target.value)}
      >
   <option value="">Select Promo Code</option>
{promoCodeList

.filter(code =>
      code.applicable_locations
        ?.split(',')
        .map(loc => loc.trim())
      .includes(String(selectedGameLocation))
    )
  .filter(code =>
    code.applicable_game_packages
      ?.split(',')
      .map(pkg => pkg.trim())
      .includes(selectedPackageType)
  )
    .filter(code => {
      // const today = new Date().toLocaleDateString("en-CA", {timeZone: 'America/Toronto'});

      // const activeFrom = code.active_from ?  new Date(code.active_from).toLocaleDateString('en-CA') : null;
      // const activeTo = code.active_to ?  new Date(code.active_to).toLocaleDateString('en-CA') : null;

    const activeFrom = code.active_from ? code.active_from : null;
    const activeTo = code.active_to ?  code.active_to : null;

      // Always active if both dates are missing
      if (!activeFrom && !activeTo) return true;

      if (activeFrom && !activeTo) return today >= activeFrom;
 
      if (!activeFrom && activeTo) return today <= activeTo;

      return today >= activeFrom && today <= activeTo;
    })
   .filter(code => {
    const selectedCount = promoDetails.filter(p => p.code_name === code.code_name).length;
   const removedCount = removedPromos.filter(p => p.code_name === code.code_name).length;
   const effectiveUsedCount = code.used_count - removedCount;
   if (!code.usable_count || code.usable_count === 0) return true;
   return code.usable_count > (effectiveUsedCount + selectedCount);
  })
  .map(code => (
    <option key={code.id} value={code.code_name}>
      {code.code_name}
    </option>
))}
      </select>
    </div>
    </div>

   

  </Modal.Body>

  <Modal.Footer>
 
  <button class="btn btn-sm btn_secondary" onClick={applyPromoCode}>
      Apply
    </button>
  </Modal.Footer>
</Modal>


        </div>
    );
}

export default EditBooking;
